var _initial;
var _revised;
var _future;
var _initialSnapshot;
var _revisedSnapshot;
var _futureSnapshot;
var _selectedRiskGuid;
var svgContainer = null;
var _isHistoryMode = true;
var _riskTypes = [];
var _riskTypeFieldNames = [];
var _riskRevampAppURL = "";
var _target = document.getElementById("#newHeatMap");
var _bIinitial = true;
var _bRevised = true;
var _bFuture = true;
var allCircles = [];
var _critiriaInfo;
var _xAxisItems = {};
var _yAxisItems = {};
var _jsonRiskMatrix;
var _jsonRiskURLs = {};
var circleRadius = 23;
var circleRadiusWithPadding = 25;
var group_AxisLabels = null;
var group_MainGroup = null;
var group_Circles = null;
var group_MatrixRectangles = null;
var rectangles = [];
var circlesPerMatrix = {};
var arrI = {};
var arrR = {};
var arrF = {};
var _circleClicked = false;
var _group_arrows = null;
var _circleToolTip = null;
var _filteredCircleMode = false;
var _xAxisFormula;
var _yAxisFormula;
var _isInitialEnabled = true;
var _isRevisedEnabled = true;
var _isFutureEnabled = true;
var _minDate = new Date();
_minDate.setFullYear(1, 0, 1);
_minDate.setHours(0, 0, 0, 0);
var _ResponsiblePersonTxt;
var _RiskTitleTxt;
var _RiskIDTxt;
var _SecondaryResponsiblePersonTxt;
var _RiskAssessmentTypeTxt;
var _RiskRatingTxt;
var _RiskTypeTxt;
var _RiskActions;
var _RiskControls;
var _KPIs;
var _Scorecards;
var _Actions;
var _HideSecondryRiskCategory;
var _HideRiskSubCategory;
var _RiskCategoryText;
var _riskRatingTypes;
var _Risks;
var _TitleText;
var _OrganisationalLinksText;
var _ReportingPeriodText;
var _NextReviewDateText;
var _CurrentRiskRatingText;
var _RiskCodeText;
var _ControlCode;
var _ControlCodeVisible;
var _ControlTitle;
var _ControlTitleVisible;
var _ControlType;
var _ControlTypeVisible;
var _ControlOwner;
var _ControlOwnerVisible;
var _ControlOwnerRating;
var _ControlOwnerRatingVisible;
var _ControlReviewDate;
var _ControlReviewDateVisible;
var _ControlNextReviewDate;
var _ControlNextReviewDateVisible;
var _fetchRiskDetails;
var _fetchHistory;
var _NoActionsDisplayMessage;
var _NoRiskDisplayMessage;
var _NoKPIdataDisplayMessage;
var _NoRiskControlsDisplayMessage;
var _isShowTimelineTrend = false;
var _translationKeyValuePair = [];
var _CommonActions;
var _EnableCommonActions = false;

var _IRF = {
    I: "Initial",
    R: "Revised",
    F: "Future",
};

var opts = {
    lines: 9, // The number of lines to draw
    length: 9, // The length of each line
    width: 5, // The line thickness
    radius: 14, // The radius of the inner circle
    color: "#EE3124", // #rgb or #rrggbb or array of colors
    speed: 1.9, // Rounds per second
    trail: 40, // Afterglow percentage
    className: "spinner", // The CSS class to assign to the spinner
};

function setTranslationValues(translationKeyValuePair) {
    _translationKeyValuePair = translationKeyValuePair;
}

function setEnableCommonActions(flag) {
    _EnableCommonActions = flag;
}

function setCircleMultiplicity(isMultiple) {
    if (isMultiple) {
        _isHistoryMode = true;
    } else {
        _isHistoryMode = false;
    }
}

function HideFields(HideSecondryRiskCategory, HideRiskSubCategory) {
    _HideSecondryRiskCategory = HideSecondryRiskCategory;
    _HideRiskSubCategory = HideRiskSubCategory;
}

function resetTimeLineTrend(){
    _isShowTimelineTrend = false;
}

function LabelReplacement(
    ResponsibleTxt,
    TitleTxt,
    IdTxt,
    RiskTypeTxt,
    RiskRatingTxt,
    RiskAssessmentTypeTxt,
    SecondaryResponsiblePersonTxt,
    RiskActions,
    RiskControls,
    KPIs,
    Scorecards,
    Actions,
    Risks,
    TitleText,
    OrganisationalLinksText,
    ReportingPeriodText,
    NextReviewDateText,
    CurrentRiskRatingText,
    RiskCodeText,
    PrimaryRiskCategoryText,
    FutureAssesmentCodeText,
    InitialAssesmentCodeText,
    RevisedAssesmentCodeText,
    RiskSubCategoryText,
    SecondaryRiskCategoryText,
    CommonActions
) {
    _ResponsiblePersonTxt = ResponsibleTxt;
    _RiskTitleTxt = TitleTxt;
    _RiskIDTxt = IdTxt;
    _SecondaryResponsiblePersonTxt = SecondaryResponsiblePersonTxt;
    _RiskAssessmentTypeTxt = RiskAssessmentTypeTxt;
    _RiskRatingTxt = RiskRatingTxt;
    _RiskTypeTxt = RiskTypeTxt;
    _RiskActions = RiskActions;
    _RiskControls = RiskControls;
    _KPIs = KPIs;
    _Scorecards = Scorecards;
    _Actions = Actions;
    _Risks = Risks;
    _TitleText = TitleText;
    _OrganisationalLinksText = OrganisationalLinksText;
    _ReportingPeriodText = ReportingPeriodText;
    _NextReviewDateText = NextReviewDateText;
    _CurrentRiskRatingText = CurrentRiskRatingText;
    _RiskCodeText = RiskCodeText;
    _PrimaryRiskCategoryText = PrimaryRiskCategoryText;
    _FutureAssesmentCodeText = FutureAssesmentCodeText;
    _InitialAssesmentCodeText = InitialAssesmentCodeText;
    _RevisedAssesmentCodeText = RevisedAssesmentCodeText;
    _CommonActions = Actions;

    if (_HideRiskSubCategory == undefined || _HideRiskSubCategory == false) {
        _RiskCategoryText = RiskSubCategoryText;
    } else {
        _RiskCategoryText = "";
    }

    if (
        _HideSecondryRiskCategory == undefined ||
        _HideSecondryRiskCategory == false
    ) {
        _RiskCategoryText = SecondaryRiskCategoryText;
    } else {
        _RiskCategoryText = "";
    }
}

function CheckFieldConfigurations(
    ControlCode,
    ControlCodeVisibile,
    ControlTitle,
    ControlTitleVisibile,
    ControlType,
    ControlTypeVisibile,
    ControlOwner,
    ControlOwnerVisibile,
    ControlOwnerRating,
    ControlOwnerRatingVisibile,
    ControlReviewDate,
    ControlReviewDateVisibile,
    ControlNextReviewDate,
    ControlNextReviewDateVisibile
) {
    _ControlCode = ControlCode;
    _ControlCodeVisible = ControlCodeVisibile == "False" ? false : true;
    _ControlTitle = ControlTitle;
    _ControlTitleVisible = ControlTitleVisibile == "False" ? false : true;
    _ControlType = ControlType;
    _ControlTypeVisible = ControlTypeVisibile == "False" ? false : true;
    _ControlOwner = ControlOwner;
    _ControlOwnerVisible = ControlOwnerVisibile == "False" ? false : true;
    _ControlOwnerRating = ControlOwnerRating;
    _ControlOwnerRatingVisible =
        ControlOwnerRatingVisibile == "False" ? false : true;
    _ControlReviewDate = ControlReviewDate;
    _ControlReviewDateVisible =
        ControlReviewDateVisibile == "False" ? false : true;
    _ControlNextReviewDate = ControlNextReviewDate;
    _ControlNextReviewDateVisible =
        ControlNextReviewDateVisibile == "False" ? false : true;
}

function getRiskURL(risk) {
    if (risk.RiskType == "Strategic") {
        return _jsonRiskURLs.SR + risk.Guid;
    } else if (risk.RiskType == "Operational") {
        return _jsonRiskURLs.OR + risk.Guid;
    } else if (risk.RiskType == "Project") {
        return _jsonRiskURLs.PR + risk.Guid;
    } else if (risk.RiskType == "Corporate") {
        return _jsonRiskURLs.CR + risk.Guid;
    }
    return "#";
}

function toggleIRF() {
    _bIinitial =
        document.getElementById("checkInitial").checked && _isInitialEnabled;
    _bRevised =
        document.getElementById("checkRevised").checked && _isRevisedEnabled;
    _bFuture =
        document.getElementById("checkFuture").checked && _isFutureEnabled;
    drawCircles();
    if(_isShowTimelineTrend){
        drawArrowsInTimelineTrend();
    }
    else{
        drawArrowsForAll();
    }    
}

function preInit(
    initialLabel,
    revisedLabel,
    futureLabel,
    NoActionsDisplayMessage,
    NoRiskDisplayMessage,
    NoKPIdataDisplayMessage,
    NoRiskControlsDisplayMessage,
    isInitialEnabled,
    isRevisedEnabled,
    isFutureEnabled
) {
    _IRF.I = initialLabel;
    _IRF.R = revisedLabel;
    _IRF.F = futureLabel;

    _isInitialEnabled = isInitialEnabled == "False" ? false : true;
    _isRevisedEnabled = isRevisedEnabled == "False" ? false : true;
    _isFutureEnabled = isFutureEnabled == "False" ? false : true;

    $("#initial_toggle").text(_IRF.I);
    $("#revised_toggle").text(_IRF.R);
    $("#future_toggle").text(_IRF.F);

    _isInitialEnabled ? $("#initialBlock").show() : $("#initialBlock").hide();
    _isRevisedEnabled ? $("#revisedBlock").show() : $("#revisedBlock").hide();
    _isFutureEnabled ? $("#futureBlock").show() : $("#futureBlock").hide();

    _NoActionsDisplayMessage = NoActionsDisplayMessage;
    _NoRiskDisplayMessage = NoRiskDisplayMessage;
    _NoKPIdataDisplayMessage = NoKPIdataDisplayMessage;
    _NoRiskControlsDisplayMessage = NoRiskControlsDisplayMessage;
}

function init(
    initialR,
    revisedR,
    futureR,
    critiriaInfo,
    jsonRiskMatrix,
    jsonRiskURLs
) {
    _bIinitial = _isInitialEnabled;
    bRevised = true;
    _bRevised = _isRevisedEnabled;
    _bFuture = _isFutureEnabled;
    _initial = initialR;
    _revised = revisedR;
    _future = futureR;
    _critiriaInfo = critiriaInfo;
    _jsonRiskMatrix = jsonRiskMatrix;
    _jsonRiskURLs = jsonRiskURLs;
    setupTheStage();
    drawRects();
    toggleIRF();
    document.getElementById("chartActions").style.display = "block";
    loading();
}

function loading() {
    try {
        document.getElementById("div_loading").show();
    } catch (e) {}
    // Browser render cycle hook to show loading panel
    window.requestAnimationFrame(function () {
        try {
            document.getElementById("div_loading").style.display = "none";
        } catch (e) {}
    });
}

function setupTheStage() {
    setSVGContainer();
    setupToolTip();
}

function setupToolTip() {
    _circleToolTip = d3
        .tip()
        .attr("class", "d3-tip")
        .offset([-10, 0])
        .html(function (d) {
            return (
                "<div style='padding-bottom: 2px'><strong>" +
                _RiskIDTxt +
                ": </strong>" +
                "<span style='color: #C6C6C6'>" +
                d.code +
                "</span></div>" +
                "<div style='padding-bottom: 2px'><strong>" +
                _RiskTitleTxt +
                ": </strong>" +
                "<span style='color: #C6C6C6'>" +
                (d.rawData.IsConfidentialStaff == "false"
                    ? getToolTipFriendlyTitle(d.Title)
                    : "Confidential Risk") +
                "</span></div>" +
                "<div style='padding-bottom: 2px'><strong>" +
                _RiskTypeTxt +
                ": </strong>" +
                "<span style='color: #C6C6C6'>" +
                d.rawData.RiskType +
                "</span></div>" +
                "<div style='padding-bottom: 2px'><strong>" +
                _RiskRatingTxt +
                ": </strong>" +
                "<span style='color: #C6C6C6'>" +
                (d.rawData.IsConfidentialStaff == "false"
                    ? d.rawData.RiskRatingTypeTitle
                    : "Confidential") +
                "</span></div>" +
                "<div style='padding-bottom: 2px'><strong>" +
                _RiskAssessmentTypeTxt +
                ": </strong>" +
                "<span style='color: #C6C6C6'>" +
                (d.rawData.IsConfidentialStaff == "false"
                    ? d.rawData.RiskAssessmentTypeName
                    : "Confidential") +
                "</span></div>" +
                ((d.rawData.IsLastReviewedDate && d.rawData.LastReviewedOn != null) 
                ?
                "<div style='padding-bottom: 2px'><strong>" +
                getDateLabel() +
                "</strong>" +
                "<span style='color: #C6C6C6'>" +
                (d.rawData.IsConfidentialStaff == "false"
                    ? convertJsonDate(d.rawData.LastReviewedOn)
                    : "Confidential") +
                "</span></div>":"") +
                "<div style='padding-bottom: 2px'><strong>" +
                _ResponsiblePersonTxt +
                ": </strong>" +
                "<span style='color: #C6C6C6'>" +
                (d.rawData.IsConfidentialStaff == "false"
                    ? d.rawData.ResponsiblePersonName
                    : "Confidential") +
                "</span></div>" +
                ((d.rawData.IsSecondaryResponsible)
                ? "<div style='padding-bottom: 2px'><strong>" +
                _SecondaryResponsiblePersonTxt +
                ": </strong>" +
                "<span style='color: #C6C6C6'>" +
                ((d.rawData.IsConfidentialStaff == "false")
                    ? d.rawData.SecondaryStaffList
                    : "Confidential") +
                "</span></div>":"")
            );
        });
    svgContainer.call(_circleToolTip);
}

function getDateLabel() {
    if (_isHistoryMode && _isShowTimelineTrend) {
        return "Saved Date: ";
    }
    return "Last Reviewed on: ";
}

function getToolTipFriendlyTitle(title) {
    if (title.length > 50) {
        return title.substring(0, 49) + "...";
    } else {
        return title;
    }
}

function getCritiriaAsTitle(critiriaText) {
    return critiriaText.replace(/\|/g, ", ").replace(/\:/g, " ");
}

function setupRiskDetailsPopup(riskDetails, showNextReviewDate) {
    $("#RiskDetailsPopup")
        .dialog({
            height: "auto",
            width: "auto",
            maxHeight: $(window).height() * 0.85,
            modal: true,
            autoOpen: false,
            resizable: true,
            position: { my: "top", at: "top+70" },
            title: riskDetails.RiskCode + " - " + riskDetails.RiskType,
            dialogClass: "wrapperEx wrapperDetails",
            open: fillRiskDetails,
        })
        .prev(".ui-dialog-titlebar");
    // .css("font-family","Graphik Regular Desktop")
    // .css("font-size", "14px")
    // .css("background", "#80A9CA");

    $("#RiskDetailsPopup")
        .data({
            riskDetails: riskDetails,
            showNextReviewDate: showNextReviewDate,
        })
        .dialog("open")

        .dialog("widget")
        .next(".ui-widget-overlay");
}

function setupDetailsBox(circle) {
    var results = circlesPerMatrix[circle.MatrixId].length - 11;
    var s = results >= 1 ? "s" : "";
    var title =
        getCritiriaAsTitle(circle.rawData.RiskCriteriaText) +
        " | " +
        results +
        " Risk" +
        s;

    $("#detailsPopup")
        .dialog({
            modal: true,
            autoOpen: false,
            resizable: false,
            title: title,
            dialogClass: "wrapperEx wrapperMore dialog-height",
            width: 600,
            close: onRiskSelectedFromMore,
            open: createDetailsTable,
        })
        .prev(".ui-dialog-titlebar");
    // .css("font-family","Graphik Regular Desktop")
    // .css("font-size", "14px")
    // .css("background", "#80A9CA");
}

function onRiskSelectedFromMore() {
    if ($("#detailsPopup").data("selectedRiskGuid") != null) {
        const args = [$("#detailsPopup").data("selectedRiskGuid")];
        _filteredCircleMode = true;
        drawCircles(args);
        group_Circles.selectAll("g").dispatch("click");
    }
}

function setShowTrackLines(showTrackLinesForAll) {
    _showTrackLinesForAll = showTrackLinesForAll;
}

function setRiskTypes(riskTypes) {
    _riskTypes = riskTypes;
}
function setRiskTypesFieldNames(riskTypeFieldNames) {
    _riskTypeFieldNames = riskTypeFieldNames;
}

function setRiskRevampAppURL(riskRevampAppURL) {
    _riskRevampAppURL = riskRevampAppURL;
}

function setXYAxis(x, y) {
    _xAxisFormula = x;
    _yAxisFormula = y;
}

function groupCirclesPerBox(isHistoryMode) {
    circlesPerMatrix = {};
    Object.keys(allCircles).forEach(function (IRFKey) {
        Object.keys(allCircles[IRFKey]).forEach(function (GUIDKey) {
            if (allCircles[IRFKey][GUIDKey].length > 0) {
                for (i = 0; i < allCircles[IRFKey][GUIDKey].length; ++i) {
                    var circle = allCircles[IRFKey][GUIDKey][i];

                    if (!(circle.MatrixId in circlesPerMatrix)) {
                        circlesPerMatrix[circle.MatrixId] = [];
                    }

                    // storing circle guid per matrix id, this will be used to figure
                    // out how much circles are assigned per box
                    // this number will be used inside the circle drawing algorithm
                    circlesPerMatrix[circle.MatrixId].push(circle);

                    // access only the first circle since isHistoryMode condition is not true
                    if (!isHistoryMode) {
                        break;
                    }
                }
            }
        });
    });
}

function changeBorder(d3Circle, bIncrease) {
    d3Circle.style("stroke", "purple").style("stroke-width", function () {
        if (bIncrease) {
            return 5;
        }
        return 0;
    });
}

function createDetailsTable() {
    $("#detailsPopup").data("selectedRiskGuid", null);
    $("#detailsPopup").empty();

    var matrixId = $("#detailsPopup").data("matrixId");
    var moreTable = $('<div class="wrapperEx" id="detailTable"></div>');

    for (i = circlesPerMatrix[matrixId].length - 1; i > 10; --i) {
        var row = $(
            '<div class="rowEx">' +
                '<div class="cellEx txt-mid-14">' +
                circlesPerMatrix[matrixId][i].code +
                "<br>" +
                " (" +
                getAssementText(circlesPerMatrix[matrixId][i].assesment) +
                ")</div>" +
                '<div class="cellEx txt-mid-14"' +
                circlesPerMatrix[matrixId][i].Title +
                "</div>" +
                '<div class="cellEx" style="width:150px"><button type="button" class="greenButton" (click)="toggleSetSelectedRisk(\'' +
                circlesPerMatrix[matrixId][i].Guid +
                "')\">Show on Map</button>" +
                "</div>" +
                "</div>"
        );
        $(row).appendTo(moreTable);
    }

    moreTable.appendTo("#detailsPopup");
}

function fillRiskDetails() {
    $("#RiskDetailsPopup").empty();
    $(".ui-dialog").addClass("AnalysisRiskDetailsPopup");
    var riskDetails = $("#RiskDetailsPopup").data("riskDetails");

    if (riskDetails.IsConfidentialStaff == "false") {
        var showNextReviewDate =
            $("#RiskDetailsPopup").data("showNextReviewDate");
        var moreTable = $('<div class="wrapperEx" id="RiskDetailTable"></div>');

        $(getGeneralDetailsHTML(riskDetails, showNextReviewDate)).appendTo(
            moreTable
        );
        moreTable.appendTo("#RiskDetailsPopup");

        var tabHtml = '<ul class="tabs-thumbs">';

        if (!_EnableCommonActions) {
            tabHtml += '<li class="tabs-thumb"><a>' + _RiskActions + '</a></li>';
        }
        if (_EnableCommonActions) {
            tabHtml += '<li class="tabs-thumb"><a>' + _CommonActions + '</a></li>';
        }

        tabHtml +=
            '<li class="tabs-thumb"><a>' + _RiskControls + '</a></li>' +
            '<li class="tabs-thumb"><a>' + _KPIs + '</a></li>' +
            '<li class="tabs-thumb"><a>' + _Risks + '</a></li>' +
            '<li class="tabs-thumb"><a>' + _Scorecards + '</a></li>';
            
        tabHtml += '</ul>';

        tabHtml += '<ul class="tabs-panels">';

        if (!_EnableCommonActions) {
            tabHtml += '<li class="tabs-panel">' +
                getTableHTML(riskDetails.ListActions, "action") +
                '</li>';
        }

        if (_EnableCommonActions) {
            const data = {
                linkedActions: riskDetails.ListCommonActions,
                actionFields: riskDetails.ActionFieldList
            };
            tabHtml += '<li class="tabs-panel">' +
                getTableHTML(data, "commonActions") +
                '</li>';
        }

        tabHtml +=
            '<li class="tabs-panel">' +
            getTableHTML(riskDetails.ListRiskControls, "riskcontrol") +
            '</li>' +
            '<li class="tabs-panel">' +
            getTableHTML(riskDetails.ListKPIs, "kpi") +
            '</li>' +
            '<li class="tabs-panel">' +
            getTableHTML(riskDetails.ListLinkedRisk, "risk") +
            '</li>' +
            '<li class="tabs-panel">' +
            getTableHTML(riskDetails.ListScorecards, "scorecard") +
            '</li>';

        tabHtml += '</ul>';

        var tabData = $(tabHtml);

        var tabControl = $('<div class="tabsEx"></div>');
        $("#RiskDetailTabs").tabs();
        $(tabData).appendTo(tabControl);
        tabControl.appendTo("#RiskDetailsPopup");

        initTabControl();
    } else {
        var permissionDenied = $(
            "<div style= 'height:300px;' class=\"permissionDeniedText\">Sorry, you don't have the required permission to view this confidential risk. <div style= 'font-size:14px; padding-top:30px; width:100%; text-align:center; font-weight:400;'> If you believe you should be having access, please speak to your Administrator</div></div>"
        );
        permissionDenied.appendTo("#RiskDetailsPopup");
    }
}

function getTableHTML(data, dataType) {
    if (dataType == "kpi") {
        if (data.length == 0) {
            return '<div class="NoData">' + _NoKPIdataDisplayMessage  +'</div>';
        }
        return (
            '<table id="tableKPI" class="tableDetails">' +
            "<thead>" +
            "<tr>" +
            "<th>Title</th>" +
            "<th>Unit</th>" +
            "<th>Reporting Period</th>" +
            "<th>Actual</th>" +
            "<th>Target</th>" +
            "<th>Performance</th>" +
            "<th>Trend</th>" +
            "</tr>" +
            "</thead>" +
            "<tbody>" +
            getKPIRows(data) +
            "</tbody>" +
            "</table>"
        );

    } else if (dataType == "commonActions") {
        if (data.linkedActions.length == 0) {
            return '<div class="NoData"> No Actions data to display </div>';
        }
              
        function getHeaderDisplayText(fieldName) {
            const field = data.actionFields.find(f => f.fieldName === fieldName);
            return field ? field.propertyDisplayText : fieldName;
        }

        return (
            '<table id="commonActions" class="tableDetails">' +
            "<thead>" +
            "<tr>" +
            '<th scope="col">' +
            getHeaderDisplayText('ActionCode') +
            '</th>' +
            '<th scope="col">' +
            getHeaderDisplayText('ActionTitle') +
            '</th>' +
            '<th scope="col" style="min-width: 100px;">' +
            getHeaderDisplayText('ActionStatus') +
            '</th>' +
            '<th scope="col" style="min-width: 170px;">' +
            getHeaderDisplayText('ResponsibleOfficer') +
            '</th>' +
            '<th scope="col" colspan="2" style="min-width: 140px;">' +
            getHeaderDisplayText('PercentageComplete') +
            '</th>' +
            '</tr>' +
            "</thead>" +
            "<tbody>" +
            getCommonActionRows(data.linkedActions) +
            "</tbody>" +
            "</table>"
        );

    }
    else if (dataType == "action") {
        if (data.length == 0) {
            return '<div class="NoData">' + _NoActionsDisplayMessage + '</div>';
        }
        return (
            '<table id="tableAction" class="tableDetails">' +
            "<thead>" +
            "<tr>" +
            '<th scope="col">Title</th>' +
            '<th scope="col" style="min-width: 170px;">' +
            _ResponsiblePersonTxt +
            "</th>" +
            '<th scope="col">Comment</th>' +
            '<th scope="col" style="min-width: 100px;">Status</th>' +
            '<th scope="col" colspan="2" style="min-width: 140px;">% Complete</th>' +
            "</tr>" +
            "</thead>" +
            "<tbody>" +
            getActionRows(data) +
            "</tbody>" +
            "</table>"
        );

    } else if (dataType == "riskcontrol") {
        if (data.length == 0) {
            return '<div class="NoData">' + _NoRiskControlsDisplayMessage +  '</div>';
        }
        var ShowHideCode =
            _ControlCodeVisible == false ? ' style="display: none;"' : "";
        var ShowHideTitle =
            _ControlTitleVisible == false ? ' style="display: none;"' : "";
        var ShowHideType =
            _ControlTypeVisible == false ? ' style="display: none;"' : "";
        var ShowHideOwner =
            _ControlOwnerVisible == false ? ' style="display: none;"' : "";
        var ShowHideOwnerRating =
            _ControlOwnerRatingVisible == false
                ? ' style="display: none;"'
                : "";
        var ShowHideReviewDate =
            _ControlReviewDateVisible == false ? ' style="display: none;"' : "";
        var ShowHideNextReviewDate =
            _ControlNextReviewDateVisible == false
                ? ' style="display: none;"'
                : "";

        return (
            '<table id="tableRiskControls" class="tableDetails">' +
            "<thead>" +
            "<tr>" +
            "<th " +
            ShowHideCode +
            ">" +
            _ControlCode +
            "</th>" +
            "<th " +
            ShowHideTitle +
            ">" +
            _ControlTitle +
            "</th>" +
            "<th " +
            ShowHideType +
            ">" +
            _ControlType +
            "</th>" +
            "<th " +
            ShowHideOwner +
            ">" +
            _ControlOwner +
            "</th>" +
            "<th " +
            ShowHideOwnerRating +
            ">" +
            _ControlOwnerRating +
            "</th>" +
            "<th " +
            ShowHideReviewDate +
            ">" +
            _ControlReviewDate +
            "</th>" +
            "<th " +
            ShowHideNextReviewDate +
            ">" +
            _ControlNextReviewDate +
            "</th>" +
            "</tr>" +
            "</thead>" +
            "<tbody>" +
            getRiskControlRows(data) +
            "</tbody>" +
            "</table>"
        );
    } else if (dataType == "risk") {
        if (data.length == 0) {
            return '<div class="NoData">' + _NoRiskDisplayMessage +  '</div>';
        }

        var riskCodeHeader =
            "<th style='min-width: 150px'>" + _RiskCodeText + "</th>";
        var riskTitleHeader =
            "<th style='min-width: 300px'>" + _TitleText + "</th>";
        // var orgLinkHeader =
        //     data[0].HiddenColumns != undefined &&
        //     data[0].HiddenColumns.includes("OrganisationalLinks")
        //         ? ""
        //         : "<th>" + _OrganisationalLinksText + "</th>";
        var riskTypeHeader =
            "<th style='min-width: 150px'>" + _RiskTypeTxt + "</th>";
        var riskOwnerHeader =
            "<th style='min-width: 155px'>" + _ResponsiblePersonTxt + "</th>";
        var reportingPeriodHeader =
            "<th style='min-width: 135px'>" + _ReportingPeriodText + "</th>";
        var nextReviewDatedHeader =
            "<th style='min-width: 140px'>" + _NextReviewDateText + "</th>";
        var currentRiskRattingHeader =
            "<th style='min-width: 151px'>" + _CurrentRiskRatingText + "</th>";

        return (
            '<div class="tableDetailsOuterDiv"><table id="tableRisks" class="tableDetails">' +
            "<thead>" +
            "<tr><th></th>" +
            riskCodeHeader +
            riskTitleHeader +
            // orgLinkHeader +
            riskTypeHeader +
            riskOwnerHeader +
            reportingPeriodHeader +
            nextReviewDatedHeader +
            currentRiskRattingHeader +
            "</tr>" +
            "</thead>" +
            "<tbody>" +
            getLinkedRiskRows(data) +
            "</tbody>" +
            "</table></div>"
        );
    }else if(dataType == "scorecard"){
        if (data.length == 0) {
            return '<div class="NoData"> No Scorecard data to display </div>';
        }
        return (
            '<table id="tableScorecard" class="tableDetails">' +
            "<thead>" +
            "<tr>" +
            "<th>Title</th>" +
            "<th>Performance</th>" +
            "</tr>" +
            "</thead>" +
            "<tbody>" +
            getScorecardRows(data) +
                "</tbody>" +
                "</table>"
            );
    }

    return "";
}

function ToggleRiskRows(riskTypeName) {
    $(".tr-" + riskTypeName).toggle();
    $("#toggle-" + riskTypeName).toggleClass("rgCollapse rgExpand");
}

function getLinkedRiskRows(data) {
    var final = "";
    var riskTypeName = "";
    for (var i = 0; i < data.length; ++i) {
        var nextReviewDate =
            data[i].NextReviewDate != null ? data[i].NextReviewDate : "";
        var reportingPeriodName =
            data[i].ReportingPeriodName != null
                ? data[i].ReportingPeriodName
                : "-";
        var currentRiskRattingImageURL = data[i].CurrentRiskRatingImageURL;
        var riskNavigationURL =
            _riskRevampAppURL +
            "/cammsrisk/create-risk/" +
            data[i].RiskTypeId +
            "/" +
            data[i].RiskId;
        if (riskTypeName != data[i].RiskTypeName) {
            riskTypeName = data[i].RiskTypeName;
            riskTypeRow =
                '<tr style="font-weight:bold">' +
                // 	'<td class="rgGroupCol"><input id=' + '"toggle-' + riskTypeName + '"' +' type="submit" onClick="ToggleRiskRows(\'' + riskTypeName + '\')"  value=" " class="rgCollapse" id=' +
                // 	'"' + riskTypeName + '"' +
                // 	'></td>'+
                "<td colspan=" +
                '"' +
                data.length +
                1 +
                '"' +
                ">" +
                "Risk Type: " +
                data[i].RiskType +
                "</td>" +
                "</tr>";
        } else {
            riskTypeName = data[i].RiskTypeName;
            riskTypeRow = "";
        }

        var titleTag = "";
        if (riskNavigationURL == "") {
            titleTag = "<td>" + data[i].Title + "</td>";
        } else {
            titleTag =
                "<td>" +
                '<a target="_blank" href=' +
                '"' +
                riskNavigationURL +
                '"' +
                ">" +
                data[i].Title +
                "</a></td>";
        }

        var riskCodeTag =
            "<td style =" +
            '"' +
            "text-align:center;" +
            '"' +
            ">" +
            data[i].RiskIdNumber +
            "</td>";
        var orgLinkTag =
            data[i].HiddenColumns != undefined &&
            data[i].HiddenColumns.includes("OrganisationalLinks")
                ? ""
                : "<td>" + data[i].OrganisationalLinks + "</td>";
        var riskTypeTag = "<td>" + data[i].RiskType + "</td>";
        var responsibleOfficerTag =
            "<td>" + data[i].ResponsiblePersonName + "</td>";
        var reportingPeriodTag = "<td>" + reportingPeriodName + "</td>";
        var nextReviewDateTag =
            '<td style="min-width: 100px;">' +
            convertJsonDate(nextReviewDate) +
            "</td>";
        var currentRiskRattingImageTag =
            "<td>" + currentRiskRattingImageURL + "</td >";

        final =
            final +
            riskTypeRow +
            "<tr class=" +
            '"tr-' +
            riskTypeName +
            '"' +
            "><td></td>" +
            riskCodeTag +
            titleTag +
            //orgLinkTag +
            riskTypeTag +
            responsibleOfficerTag +
            reportingPeriodTag +
            nextReviewDateTag +
            currentRiskRattingImageTag +
            "</tr>";
    }

    return final;
}

function getActionRows(data) {
    var final = "";
    for (var i = 0; i < data.length; ++i) {
        final =
            final +
            "<tr>" +
            "<td>" +
            (data[i].Title ?? "-") +
            "</td>" +
            "<td>" +
            (data[i].ResponsibleOfficerName ?? "-") +
            "</td>" +
            "<td>" +
            (data[i].Comment ?? "-") +
            "</td>" +
            "<td>" +
            (data[i].Status ?? "-") +
            "</td>" +
            "<td>" +
            "<strong>" +
            (data[i].PercentageComplete ?? "0") +
            "%</strong>" +
            "</td>" +
            '<td style="min-width: 120px">' +
            '<div class="progress-wrap progress" data-progress-percent="' +
            (data[i].PercentageComplete ?? "0") +
            '">' +
            '<div class="progress-bar progress"></div>' +
            "</div>" +
            "</td>" +
            "</tr>";
    }

    return final;
}

function getRiskControlRows(data) {
    var final = "";
    var ShowHideCode =
        _ControlCodeVisible == false ? ' style="display: none;"' : "";
    var ShowHideTitle =
        _ControlTitleVisible == false ? ' style="display: none;"' : "";
    var ShowHideType =
        _ControlTypeVisible == false ? ' style="display: none;"' : "";
    var ShowHideOwner =
        _ControlOwnerVisible == false ? ' style="display: none;"' : "";
    var ShowHideOwnerRating =
        _ControlOwnerRatingVisible == false ? ' style="display: none;"' : "";
    var ShowHideReviewDate =
        _ControlReviewDateVisible == false ? " display: none;" : "";
    var ShowHideNextReviewDate =
        _ControlNextReviewDateVisible == false ? "display: none;" : "";

    for (var i = 0; i < data.length; ++i) {
        var code = data[i].ControlCode != null ? data[i].ControlCode : "";
        var title = data[i].ControlTitle != null ? data[i].ControlTitle : "";
        var type = data[i].ControlType != null ? data[i].ControlType : "";
        var owner = data[i].ControlOwner != null ? data[i].ControlOwner : "";
        var ownerRating =
            data[i].ControlOwnerRating != null
                ? data[i].ControlOwnerRating
                : "";
        var reviewDate =
            data[i].ControlReviewDate != null ? data[i].ControlReviewDate : "";
        var nextReviewDate =
            data[i].NextReviewDate != null
                ? data[i].NextReviewDate
                : "";

        final =
            final +
            "<tr>" +
            "<td " +
            ShowHideCode +
            ">" +
            code +
            "</td>" +
            "<td " +
            ShowHideTitle +
            ">" +
            title +
            "</td>" +
            "<td " +
            ShowHideType +
            ">" +
            type +
            "</td>" +
            "<td " +
            ShowHideOwner +
            ">" +
            owner +
            "</td>" +
            "<td " +
            ShowHideOwnerRating +
            ">" +
            ownerRating +
            "</td>" +
            '<td style="min-width: 100px; ' +
            ShowHideReviewDate +
            '">' +
            convertJsonDate(reviewDate) +
            "</td>" +
            '<td style="min-width: 112px; ' +
            ShowHideNextReviewDate +
            '">' +
            nextReviewDate +
            "</td>" +
            "</tr>";
    }

    return final;
}
function getScorecardRows(data) {
    var final = "";
    for (var i = 0; i < data.length; ++i) {
        final =
            final +
            "<tr>" +
            "<td>" +
            (data[i].Title ?? "-") +
            "</td>" +
           
            "<td>" + 
            (data[i].Performance ?? "-") +
            "</td>" +
             
            "</tr>";
    }
    return final;
}
function getKPIRows(data) {
    var final = "";
    for (var i = 0; i < data.length; ++i) {
        final =
            final +
            "<tr>" +
            "<td>" +
            (data[i].Title ?? "-") +
            "</td>" +
            "<td>" +
            (data[i].Unit ?? "-") +
            "</td>" +
            "<td>" +
            (data[i].ReportingPeriod ?? "-") +
            "</td>" +
            "<td>" +
            (data[i].Actual ?? "-") +
            "</td>" +
            "<td>" +
            (data[i].Target ?? "-") +
            "</td>" +  
            "<td>" + 
            (data[i].Performance ?? "-") +
            "</td>" +
            "<td>" +
            (data[i].Trend ?? "-") +
            "</td>" +       
            "</tr>";
    }
    return final;
}

function getCommonActionRows(data) {

    var final = "";
    for (var i = 0; i < data.length; ++i) {

        final +=
            "<tr>" +
            "<td>" +
            (data[i].ActionCode ?? "-") +
            "</td>" +
            "<td>" +
            (data[i].ActionTitle ?? "-") +
            "</td>" +
            "<td>" +            
            (data[i].Status ?? "-") +
            "</td>" +
            "<td>" +
            (data[i].ResponsibleOfficer ?? "-") +
            "</td>" +
             "<td>" +
            "<strong>" +
            (data[i].PercentageComplete ?? "0") +
            "%</strong>" +
            "</td>" +
            "<td style='min-width: 120px;'>" +
            '<div class="progress-wrap progress" data-progress-percent="' +
            (data[i].PercentageComplete ?? "0") +
            '">' +
            '<div class="progress-bar progress"></div>' +
            "</div>" +
            "</td>" +
            "</tr>";
    }
    return final;
}

function moveProgressBar() {
    $(".progress-wrap").each(function (i, obj) {
        var progressVal = $(this).data("progress-percent");
        var getPercent = progressVal / 100;
        var getProgressWrapWidth = $(this).width();
        var progressTotal = getPercent * getProgressWrapWidth;
        var animationLength = 1500;

        $(this).css(
            "background-color",
            (function (val) {
                if (val < 25) {
                    return "#DB4437";
                } else if (val >= 25 && val < 75) {
                    return "#3494D1";
                } else {
                    return "#57AD68";
                }
            })(progressVal)
        );

        $(this).children(".progress-bar").stop().animate(
            {
                left: progressTotal,
            },
            animationLength
        );
    });
}

function getCustomControls(customControls) {
    var finalString = "";
    var rex = /(<([^>]+)>)/gi;

    Object.keys(customControls).forEach(function (key) {
        if (customControls.hasOwnProperty(key)) {
            finalString =
                finalString +
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                customControls[key]?.key +
                "</div>" +
                '<div class="cellEx cellValue">' +
                (customControls[key] != null && customControls[key] != undefined
                    ? customControls[key]?.value.replace(rex, "")
                    : "") +
                "</div>" +
                "</div>";
        }
    });

    return finalString;
}

function getGeneralDetailsHTML(riskDetails, showNextReviewDate) {
    if (!riskDetails.CausesVisibility && !riskDetails.ConsequencesVisible) {
        return $(
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _ResponsiblePersonTxt +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.ResponsiblePerson +
                "</div>" +
                "</div>" +
                ((riskDetails.IsSecondaryResponsible == "true")
                ?
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _SecondaryResponsiblePersonTxt +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.SecondaryStaffList +
                "</div>" +
                "</div>":"") +
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _RiskTitleTxt +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.RiskTitle +
                "</div>" +
                "</div>" +
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _PrimaryRiskCategoryText +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.PrimaryRiskCategory +
                "</div>" +
                "</div>" +
                ((riskDetails.IsSecondaryRiskCategory == "true")
                ?
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _RiskCategoryText +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.SecondaryRiskCategoryList +
                "</div>" +
                "</div>" +
                "</div>":"") +
                getInitialTags(riskDetails) +
                getRevisedTags(riskDetails) +
                getFutureTags(riskDetails) +
                getCustomControls(riskDetails.CustomControls) +
                (showNextReviewDate === 1
                    ? '<div class="rowEx">' +
                      '<div class="cellEx cellKey txt-mid-14">' + 
                      _NextReviewDateText +
                      "</div>" +
                      '<div class="cellEx cellValue">' +
                      riskDetails.NextReviewDate +
                      "</div>" +
                      "</div>"
                    : "")
        );
    } else if (!riskDetails.CausesVisibility) {
        return $(
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _ResponsiblePersonTxt +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.ResponsiblePerson +
                "</div>" +
                "</div>" +
                ((riskDetails.IsSecondaryResponsible == "true")
                ?
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _SecondaryResponsiblePersonTxt +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.SecondaryStaffList +
                "</div>" +
                "</div>":"") +
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _RiskTitleTxt +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.RiskTitle +
                "</div>" +
                "</div>" +
                //'<div class="rowEx">' +
                //	'<div class="cellEx"><strong>Rating Change</strong></div>' +
                //	'<div class="cellEx">' +
                //        '<div style="float: left; padding-right: 5px; padding-top: 5px">' +
                //            '<div class="ratingImage">' +
                //                '<img src=' + '"' + riskDetails.InitialRatingIconURL + '"' + '/>' +
                //            '</div>' +
                //            riskDetails.InitialRating +
                //        '</div>' +
                //        '<div style="float: left; padding-right: 5px; padding-top: 5px">' +
                //            '<div class="ratingImage">' +
                //                '<img src=' + '"' + riskDetails.RevisedRatingIconURL + '"' + '/>' +
                //            '</div>' +
                //            riskDetails.RevisedRating +
                //        '</div>' +
                //        '<div style="float: left; padding-right: 5px; padding-top: 5px">' +
                //            '<div class="ratingImage">' +
                //                '<img src=' + '"' + riskDetails.FutureRatingIconURL + '"' + '/>' +
                //            '</div>' +
                //            riskDetails.FutureRating +
                //        '</div>' +
                //	'</div>' +
                //'</div>' +
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _PrimaryRiskCategoryText +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.PrimaryRiskCategory +
                "</div>" +
                "</div>" +
                ((riskDetails.IsSecondaryRiskCategory == "true")
                ?
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _RiskCategoryText +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.SecondaryRiskCategoryList +
                "</div>" +
                "</div>":"") +
                //'<div class="rowEx" id="CausesRowID">' +
                //	'<div class="cellEx cellKey"><strong>Causes</strong></div>' +
                //	'<div class="cellEx cellValue">' + riskDetails.Causes + '</div>' +
                //'</div>' +
                '<div class="rowEx" id="ConsequencesRowID">' +
                '<div class="cellEx cellKey txt-mid-14">Consequences</div>' +
                '<div class="cellEx cellValue">' +
                riskDetails.Consequences +
                "</div>" +
                "</div>" +
                getInitialTags(riskDetails) +
                getRevisedTags(riskDetails) +
                getFutureTags(riskDetails) +
                getCustomControls(riskDetails.CustomControls) +
                (showNextReviewDate === 1
                    ? '<div class="rowEx">' +
                      '<div class="cellEx cellKey txt-mid-14">' +
                      _NextReviewDateText +
                      "</div>" +
                      '<div class="cellEx cellValue">' +
                      riskDetails.NextReviewDate +
                      "</div>" +
                      "</div>"
                    : "")
        );
    } else if (!riskDetails.ConsequencesVisible) {
        return $(
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _ResponsiblePersonTxt +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.ResponsiblePerson +
                "</div>" +
                "</div>" +
                ((riskDetails.IsSecondaryResponsible == "true")
                ?
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _SecondaryResponsiblePersonTxt +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.SecondaryStaffList +
                "</div>" +
                "</div>":"") +
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _RiskTitleTxt +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.RiskTitle +
                "</div>" +
                "</div>" +
                //'<div class="rowEx">' +
                //	'<div class="cellEx"><strong>Rating Change</strong></div>' +
                //	'<div class="cellEx">' +
                //        '<div style="float: left; padding-right: 5px; padding-top: 5px">' +
                //            '<div class="ratingImage">' +
                //                '<img src=' + '"' + riskDetails.InitialRatingIconURL + '"' + '/>' +
                //            '</div>' +
                //            riskDetails.InitialRating +
                //        '</div>' +
                //        '<div style="float: left; padding-right: 5px; padding-top: 5px">' +
                //            '<div class="ratingImage">' +
                //                '<img src=' + '"' + riskDetails.RevisedRatingIconURL + '"' + '/>' +
                //            '</div>' +
                //            riskDetails.RevisedRating +
                //        '</div>' +
                //        '<div style="float: left; padding-right: 5px; padding-top: 5px">' +
                //            '<div class="ratingImage">' +
                //                '<img src=' + '"' + riskDetails.FutureRatingIconURL + '"' + '/>' +
                //            '</div>' +
                //            riskDetails.FutureRating +
                //        '</div>' +
                //	'</div>' +
                //'</div>' +
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _PrimaryRiskCategoryText +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.PrimaryRiskCategory +
                "</div>" +
                "</div>" +
                ((riskDetails.IsSecondaryRiskCategory == "true")
                ?
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _RiskCategoryText +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.SecondaryRiskCategoryList +
                "</div>" +
                "</div>":"") +
                '<div class="rowEx" id="CausesRowID">' +
                '<div class="cellEx cellKey txt-mid-14">Causes</div>' +
                '<div class="cellEx cellValue">' +
                riskDetails.Causes +
                "</div>" +
                "</div>" +
                getInitialTags(riskDetails) +
                getRevisedTags(riskDetails) +
                getFutureTags(riskDetails) +
                getCustomControls(riskDetails.CustomControls) +
                (showNextReviewDate === 1
                    ? '<div class="rowEx">' +
                      '<div class="cellEx cellKey txt-mid-14">' +
                      _NextReviewDateText +
                      "</div>" +
                      '<div class="cellEx cellValue">' +
                      riskDetails.NextReviewDate +
                      "</div>" +
                      "</div>"
                    : "")
        );
    } else {
        return $(
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _ResponsiblePersonTxt +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.ResponsiblePerson +
                "</div>" +
                "</div>" +
                ((riskDetails.IsSecondaryResponsible == "true")
                ?
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _SecondaryResponsiblePersonTxt +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.SecondaryStaffList +
                "</div>" +
                "</div>":"") +
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _RiskTitleTxt +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.RiskTitle +
                "</div>" +
                "</div>" +
                //'<div class="rowEx">' +
                //	'<div class="cellEx"><strong>Rating Change</strong></div>' +
                //	'<div class="cellEx">' +
                //        '<div style="float: left; padding-right: 5px; padding-top: 5px">' +
                //            '<div class="ratingImage">' +
                //                '<img src=' + '"' + riskDetails.InitialRatingIconURL + '"' + '/>' +
                //            '</div>' +
                //            riskDetails.InitialRating +
                //        '</div>' +
                //        '<div style="float: left; padding-right: 5px; padding-top: 5px">' +
                //            '<div class="ratingImage">' +
                //                '<img src=' + '"' + riskDetails.RevisedRatingIconURL + '"' + '/>' +
                //            '</div>' +
                //            riskDetails.RevisedRating +
                //        '</div>' +
                //        '<div style="float: left; padding-right: 5px; padding-top: 5px">' +
                //            '<div class="ratingImage">' +
                //                '<img src=' + '"' + riskDetails.FutureRatingIconURL + '"' + '/>' +
                //            '</div>' +
                //            riskDetails.FutureRating +
                //        '</div>' +
                //	'</div>' +
                //'</div>' +
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _PrimaryRiskCategoryText +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.PrimaryRiskCategory +
                "</div>" +
                "</div>" +
                ((riskDetails.IsSecondaryRiskCategory == "true")
                ?
                '<div class="rowEx">' +
                '<div class="cellEx cellKey txt-mid-14">' +
                _RiskCategoryText +
                "</div>" +
                '<div class="cellEx cellValue">' +
                riskDetails.SecondaryRiskCategoryList +
                "</div>" +
                "</div>":"") +
                '<div class="rowEx" id="CausesRowID">' +
                '<div class="cellEx cellKey txt-mid-14">Causes</div>' +
                '<div class="cellEx cellValue">' +
                riskDetails.Causes +
                "</div>" +
                "</div>" +
                '<div class="rowEx" id="ConsequencesRowID">' +
                '<div class="cellEx cellKey txt-mid-14">Consequences</div>' +
                '<div class="cellEx cellValue">' +
                riskDetails.Consequences +
                "</div>" +
                "</div>" +
                getInitialTags(riskDetails) +
                getRevisedTags(riskDetails) +
                getFutureTags(riskDetails) +
                getCustomControls(riskDetails.CustomControls) +
                (showNextReviewDate === 1
                    ? '<div class="rowEx">' +
                      '<div class="cellEx cellKey txt-mid-14">' +
                      _NextReviewDateText +
                      "</div>" +
                      '<div class="cellEx cellValue">' +
                      riskDetails.NextReviewDate +
                      "</div>" +
                      "</div>"
                    : "")
        );
    }
}

function getInitialTags(riskDetails) {
    if (_isInitialEnabled) {
        return (
            '<div class="rowEx">' +
            '<div class="cellEx cellKey txt-mid-14">' +
            _IRF.I +
            "</div>" +
            '<div class="cellEx cellExRatings cellValue">' +
            (riskDetails.InitialRating
                ? getImageTag(riskDetails.InitialRatingIconURL) +
                  riskDetails.InitialRating
                : "-") +
            "</div>" +
            "</div>"
        );
    }
    return "";
}
function getRevisedTags(riskDetails) {
    if (_isRevisedEnabled) {
        return (
            '<div class="rowEx">' +
            '<div class="cellEx cellKey txt-mid-14">' +
            _IRF.R +
            "</div>" +
            '<div class="cellEx cellExRatings cellValue">' +
            (riskDetails.RevisedRating
                ? getImageTag(riskDetails.RevisedRatingIconURL) +
                  riskDetails.RevisedRating
                : "-") +
            "</div>" +
            "</div>"
        );
    }
    return "";
}
function getFutureTags(riskDetails) {
    if (_isFutureEnabled) {
        return (
            '<div class="rowEx">' +
            '<div class="cellEx cellKey txt-mid-14">' +
            _IRF.F +
            "</div>" +
            '<div class="cellEx cellExRatings cellValue">' +
            (riskDetails.FutureRating
                ? getImageTag(riskDetails.FutureRatingIconURL) +
                  riskDetails.FutureRating
                : "-") +
            "</div>" +
            "</div>"
        );
    }
    return "";
}

function getImageTag(imageURL) {
    if (imageURL != "-") {
        return (
            '<div class="ratingImage">' +
            "<img src=" +
            '"' +
            imageURL +
            '"' +
            "/>" +
            "</div>"
        );
    }
    return "";
}

function initTabControl() {
    $(".tabs-thumb:first-child")
        .addClass("is-active")
        .closest(".tabsEx")
        .find(".tabs-panel:first-child")
        .show();
    moveProgressBar();

    $(window).resize(function () {
        moveProgressBar();
    });

    $(".tabs-thumb").click(function () {
        // Cancel the siblings
        $(this)
            .siblings(".tabs-thumb")
            .removeClass("is-active")
            .closest(".tabsEx")
            .find(".tabs-panel")
            .hide();
        // Active the thumb & panel
        $(this)
            .addClass("is-active")
            .closest(".tabsEx")
            .find(".tabs-panel")
            .eq($(this).index(".tabs-thumb"))
            .show();
        moveProgressBar();
    });
}

function getCommaSeperatedString(array) {
    var finalStr = "";

    for (i = 0; i < array.length; ++i) {
        finalStr = finalStr + array[i];
        if (i == array.length - 1) {
            break;
        } else {
            finalStr = finalStr + ", ";
        }
    }

    return finalStr;
}

function drawArrowsForAll() {
    if (!_circleClicked) {
        if (_showTrackLinesForAll) {
            group_Circles.selectAll("g").each(function (d) {
                drawArrows(d.Guid, this, 2);
            });
        } else {
            highlightCircles();
        }
    }
}

function drawArrows(guid, group, lineWidth) {
    var arrayI = [];
    var arrayR = [];
    var arrayF = [];

    var matchingCircles = group_Circles
        .selectAll("g")
        .filter(function (d) {
            return guid == d.Guid;
        })
        .each(function (g) {
            var d3Circle = d3.select(this).select("circle");

            if (g.assesment == "I") {
                arrayI.push(d3Circle);
            } else if (g.assesment == "R") {
                arrayR.push(d3Circle);
            } else {
                arrayF.push(d3Circle);
            }
        });

    drawArrowsForHiddenCircles(guid, arrayI, arrayR, arrayF);

    // TODO: Test if actually dates are sorted
    arrayI.sort(comapareDates);
    arrayR.sort(comapareDates);
    arrayF.sort(comapareDates);

    var temp = drawArrowPaths(null, arrayI, group, lineWidth);
    temp = drawArrowPaths(temp, arrayR, group, lineWidth);
    temp = drawArrowPaths(temp, arrayF, group, lineWidth);
}

function drawArrowPaths(startCircle, arrCirles, group, lineWidth) {
    for (i = 0; i < arrCirles.length; ++i) {
        if (startCircle != null) {
            drawArrowLine(startCircle, arrCirles[i], group, lineWidth);
        }

        startCircle = arrCirles[i];
    }

    return startCircle;
}

function drawArrowLine(circleA, circleB, group, lineWidth) {
    var xA = circleA.attr("cx");
    var yA = circleA.attr("cy");
    var xB = circleB.attr("cx");
    var yB = circleB.attr("cy");
    var radA = parseInt(circleA.attr("r"));
    var radB = parseInt(circleB.attr("r"));

    var diffX = xB - xA;
    var diffY = yB - yA;

    // Length of path from center of source node to center of target node
    var pathLength = Math.sqrt(diffX * diffX + diffY * diffY);

    // x and y distances from center to outside edge of target node
    var offsetX = (diffX * radA) / pathLength;
    var offsetY = (diffY * radA) / pathLength;

    var pathStr =
        "M" +
        (xA - -1 * offsetX) +
        "," +
        (yA - -1 * offsetY) +
        "L" +
        (xB - offsetX) +
        "," +
        (yB - offsetY);

    var path = d3
        .select(group)
        .append("path")
        .attr("marker-end", "url(#arrow)")
        .attr("width", 3)
        .attr("tabindex", "0")
        .attr("aria-label", function () {
            return `
            ${" Moving to "}
            ${circleB?._groups[0][0]?.__data__?.MatrixId || ""}
            ${_RiskIDTxt || ""} 
            ${circleB?._groups[0][0]?.__data__?.code || ""} 
            ${_RiskTitleTxt || ""} 
            ${circleB?._groups[0][0]?.__data__?.Title || ""} 
            ${_RiskTypeTxt || ""} 
            ${circleB?._groups[0][0]?.__data__?.RiskType || ""} 
            ${_RiskRatingTxt || ""} 
            ${circleB?._groups[0][0]?.__data__?.rawData?.RiskRatingTypeTitle || ""} 
            ${_RiskAssessmentTypeTxt || ""} 
            ${circleB?._groups[0][0]?.__data__?.rawData?.RiskAssessmentTypeName || ""}
            ${getDateLabel() || ""} 
            ${circleB?._groups[0][0]?.__data__?.LastReviewedOn || ""}
            ${_ResponsiblePersonTxt || ""} 
            ${circleB?._groups[0][0]?.__data__?.rawData?.ResponsiblePersonName || ""} 
            `.trim();
        })
        .style("stroke", "purple")
        .style("stroke-width", lineWidth)
        .style("fill", "#F0F0F0")
        .attr("d", pathStr);

    if (circleB.datum().assesment == "F") {
        path.style("stroke-dasharray", "10,3");
    }
}

function highlightCircles(guid) {
    group_Circles
        .selectAll("g")
        .transition("opacity")
        .attr("fill-opacity", function (d) {
            var d3Circle = d3.select(this).select("circle");
            d3.select(this).selectAll("path").remove();

            if (guid != null) {
                if (d.Guid != guid) {
                    changeBorder(d3Circle, false);
                    return 0.3;
                } else {
                    changeBorder(d3Circle, true);
                    return 1;
                }
            } else {
                changeBorder(d3Circle, false);
                return 1;
            }
        });
}

function drawCircle(circleCount, box, circle, circleIndex) {
    var center = box.x + box.width / 2;
    var cx, cy, movement;
    circle.isInGrid = true;

    if (circleCount == 3 || circleCount == 1) {
        movement = circleRadiusWithPadding * 2;

        if (circleIndex == 0) {
            cx = center;
        } else if (circleIndex == 1) {
            cx = center + movement;
        } else if (circleIndex == 2) {
            cx = center - movement;
        }

        cy = box.y + box.height / 2;
    } else if (circleCount == 2 || circleCount == 4) {
        movement = circleRadiusWithPadding * 3;

        if (circleIndex == 0) {
            cx = center + circleRadiusWithPadding;
        } else if (circleIndex == 1) {
            cx = center - circleRadiusWithPadding;
        } else if (circleIndex == 2) {
            cx = center + movement;
        } else if (circleIndex == 3) {
            cx = center - movement;
        }

        cy = box.y + box.height / 2;
    } else if ((circleCount > 4) & (circleCount < 9)) {
        cy = box.y + box.height / 2 - circleRadiusWithPadding;
        movement = circleRadiusWithPadding * 3;

        if (circleIndex == 0) {
            cx = center + circleRadiusWithPadding;
        } else if (circleIndex == 1) {
            cx = center - circleRadiusWithPadding;
        } else if (circleIndex == 2) {
            cx = center + movement;
        } else if (circleIndex == 3) {
            cx = center - movement;
        }

        if (circleIndex > 3) {
            cy = box.y + box.height / 2 + circleRadiusWithPadding;

            if (circleIndex == 4) {
                cx = center + circleRadiusWithPadding;
            } else if (circleIndex == 5) {
                cx = center - circleRadiusWithPadding;
            } else if (circleIndex == 6) {
                cx = center + movement;
            } else if (circleIndex == 7) {
                cx = center - movement;
            }
        }
    } else if (circleCount > 8) {
        cy = box.y + circleRadiusWithPadding + 5;
        movement = circleRadiusWithPadding * 3;

        if (circleIndex == 0) {
            cx = center + circleRadiusWithPadding;
        } else if (circleIndex == 1) {
            cx = center - circleRadiusWithPadding;
        } else if (circleIndex == 2) {
            cx = center + movement;
        } else if (circleIndex == 3) {
            cx = center - movement;
        }

        if (circleIndex > 3) {
            cy = box.y + box.height / 2;

            if (circleIndex == 4) {
                cx = center + circleRadiusWithPadding;
            } else if (circleIndex == 5) {
                cx = center - circleRadiusWithPadding;
            } else if (circleIndex == 6) {
                cx = center + movement;
            } else if (circleIndex == 7) {
                cx = center - movement;
            }

            if (circleIndex > 7) {
                cy = box.y + box.height / 2 + circleRadiusWithPadding + 5;

                if (circleIndex == 8) {
                    cx = center - movement;
                } else if (circleIndex == 9) {
                    cx = center - circleRadiusWithPadding;
                } else if (circleIndex == 10) {
                    cx = center + circleRadiusWithPadding;
                } else if (circleIndex == 11) {
                    circle.isInGrid = false;
                    circle.isMoreCircle = true;
                    cx = center + movement;
                } else {
                    circle.isInGrid = false;
                    return;
                }
            }
        }
    } else {
        circle.isInGrid = false;
        return;
    }

    var circleSubGroup = group_Circles
        .append("g")
        .datum(circle)
        .attr("id", circle.Guid)
        .attr("tabindex", "0")
        .attr("aria-label", function () {
            return `
            ${circle?.MatrixId || ""}
            ${_RiskIDTxt || ""} 
            ${circle?.code || ""} 
            ${_RiskTitleTxt || ""} 
            ${circle?.Title || ""} 
            ${_RiskTypeTxt || ""} 
            ${circle?.RiskType || ""} 
            ${_RiskRatingTxt || ""} 
            ${circle?.rawData?.RiskRatingTypeTitle || ""} 
            ${_RiskAssessmentTypeTxt || ""} 
            ${circle?.rawData?.RiskAssessmentTypeName || ""}
            ${getDateLabel() || ""} 
            ${circle?.LastReviewedOn || ""}
            ${_ResponsiblePersonTxt || ""} 
            ${circle?.rawData?.ResponsiblePersonName || ""}
            `.trim();
        })
        .on("mouseover", function (d) {
            d3.select(this).style("cursor", "pointer");
            d3.select(this).select("text").attr("font-size", "14px");
            d3.select(this)
                .select("circle")
                .attr("r", circleRadius + 3);
        })
        .on("mouseout", function (d) {
            d3.select(this).style("cursor", "default");
            d3.select(this).select("text").attr("font-size", "13px");
            d3.select(this).select("circle").attr("r", circleRadius);
        })
        .on("click", function (d) {
            if (d.isInGrid) {
                if (_circleToolTip != null) {
                    _circleToolTip.hide(d);
                }

                if (!_circleClicked && _isHistoryMode) {
                    return;
                }

                showDetails(d);
                highlightCircles(d.Guid);
                drawArrows(d.Guid, this, 4);
                group_Circles.selectAll("g").sort(function (a, b) {
                    return changeCircleZIndex(a, d);
                });
            } else {
                showMorePopup(d);
            }
        });

    circle.d3Group = circleSubGroup;


    circleSubGroup
        .append("circle")
        .attr("cx", cx)
        .attr("cy", cy)
        .attr("r", circleRadius)
        .on("mouseover", function (d) {
            if (d.isInGrid) {
                _circleToolTip.offset([-10, 0]);
                _circleToolTip.show(d);
            }
        })
        .on("mouseout", function (d) {
            _circleToolTip.hide(d);
        })
        .style("fill", function (d) {
            return getCircleColor(circle.assesment);
        });

    circleSubGroup
        .append("text")
        .attr("aria-hidden", "true")
        .text(function (d) {
            if (circleIndex == 11) {
                return "...";
            }
            if (circle.code.toString().length > 6) {
                return circle.code.toString().substring(0, 5).concat("..");
            }
            return circle.code;
        })
        .on("mouseover", function (d) {
            if (d.isInGrid) {
                _circleToolTip.offset([-30, 0]);
                _circleToolTip.show(d);
            }
        })
        .on("mouseout", function (d) {
            _circleToolTip.hide(d);
        })
        .attr("x", cx)
        .attr("y", cy + 5)
        .attr("font-family", "Graphik Semibold Desktop")
        .attr("font-size", "13px")
        .attr("color", "#323250")
        .attr("font-weight", "normal")
        .attr("text-anchor", "middle")
        .style("fill", function (d) {
            if (circle.assesment == "F") {
                return "white";
            }
            return "black";
        });
    // document.getElementById("text").style.fontFamily = "Graphik Regular Desktop";
}

function hideToolTipWhenLoading(){
    //FD98773 - this method is added to prevent openening tooltip when loading nodes
    var items = document.getElementsByClassName('d3-tip');
    
    if(items.length > 0){
        for (var i = 0; i < items.length; i++) {
            items[i].style.opacity = '0';
        }
    }
}

function showMorePopup(circle) {
    setupDetailsBox(circle);

    $("#detailsPopup").data("matrixId", circle.MatrixId).dialog("open");
}

function showDetails(circle) {
    _circleClicked = true;
    var spans = document
        .getElementById("riskDetails")
        .getElementsByTagName("span");
    for (i = 0; i < spans.length; ++i) {
        var span = spans[i];
        if (span.id == "dt-risk-code") {
            setSpanValue(span, circle.code);
        } else if (span.id == "dt-risk-title") {
            setSpanValue(span, circle.Title);
        }
    }

    $("#detailsURL")
        .off()
        .on("click", function () {
            _fetchRiskDetails(circle.Guid, circle.RiskType);
        });

    $("#checkFetchHistory")
        .unbind("change")
        .change(function () {
            _isShowTimelineTrend = this.checked;
            if (this.checked) {
                saveSnapshot(circle.Guid);
                _fetchHistory(circle.Guid);
            } else {
                restoreSnapshot();
            }
        });

    $("#riskDetails").slideDown("slow");
}

function toggleDetailsVisibility(visibility) {
    document.getElementById("riskDetails").style.display = visibility;
}

function setSpanValue(span, val) {
    while (span.firstChild) {
        span.removeChild(span.firstChild);
    }
    span.appendChild(document.createTextNode(val));
}

function changeCircleZIndex(a, d) {
    if (a.Guid != d.Guid) {
        return -1;
    } else {
        return 1;
    }
}

function setSelectedRisk(guid) {
    var popup = $("#detailsPopup");
    popup.data("selectedRiskGuid", guid);
    popup.dialog("close");
}

function isValidRiskType(riskType) {
    if (!Array.prototype.includes) {
        Object.defineProperty(Array.prototype, "includes", {
            value: function (searchElement, fromIndex) {
                // 1. Let O be ? ToObject(this value).
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                var o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;

                // 3. If len is 0, return false.
                if (len === 0) {
                    return false;
                }

                // 4. Let n be ? ToInteger(fromIndex).
                //    (If fromIndex is undefined, this step produces the value 0.)
                var n = fromIndex | 0;

                // 5. If n ≥ 0, then
                //  a. Let k be n.
                // 6. Else n < 0,
                //  a. Let k be len + n.
                //  b. If k < 0, let k be 0.
                var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

                function sameValueZero(x, y) {
                    return (
                        x === y ||
                        (typeof x === "number" &&
                            typeof y === "number" &&
                            isNaN(x) &&
                            isNaN(y))
                    );
                }

                // 7. Repeat, while k < len
                while (k < len) {
                    // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                    // b. If SameValueZero(searchElement, elementK) is true, return true.
                    // c. Increase k by 1.
                    if (sameValueZero(o[k], searchElement)) {
                        return true;
                    }
                    k++;
                }

                // 8. Return false
                return false;
            },
        });
    }

    return (
        _riskTypeFieldNames.includes(riskType)
    );
}

function drawCircles(guidList) {
    d3.select("#group_circles").remove();
    group_Circles = group_MainGroup.append("g").attr("id", "group_circles");

    if (!_isHistoryMode) {
        _circleClicked = false;
        $("#riskDetails").slideUp("slow");
    } else {
        _circleClicked = true;
        $("#riskDetails").slideDown("slow");
    }

    arrI = {};
    arrR = {};
    arrF = {};
    allCircles = {};
    group_Circles.selectAll("g").remove();

    if (_bIinitial) {
        var riskMatrixId;
        var guid;

        for (i = 0; i < _initial.length; ++i) {
            guid = _initial[i].Guid;

            if (guidList != null && jQuery.inArray(guid, guidList) == -1) {
                continue;
            }

            if (
                _initial[i].RiskCriteriaText == null ||
                _initial[i].RiskCriteriaText == "" ||
                _initial[i].RiskCriteriaText.indexOf("N/A") !== -1 ||
                _initial[i].Code == null
            ) {
                continue;
            }

            if (!isValidRiskType(_initial[i].RiskFieldName)) {
                continue;
            }

            riskMatrixId = getCircleGroup(_initial[i].RiskCriteriaText);

            var circle = {
                Guid: _initial[i].Guid,
                rawData: _initial[i],
                code: _initial[i].Code,
                assesment: "I",
                RiskType: _initial[i].RiskType + " Risk",
                Title: _initial[i].Title,
                MatrixId: riskMatrixId,
                LastReviewedOn: _initial[i].LastReviewedOn,
            };

            if (!(guid in arrI)) {
                arrI[guid] = [];
            }

            arrI[guid].push(circle);
        }

        allCircles.I = arrI;
    }

    if (_bRevised) {
        var riskMatrixId;
        var guid;

        for (i = 0; i < _revised.length; ++i) {
            guid = _revised[i].Guid;
            if (guidList != null && jQuery.inArray(guid, guidList) == -1) {
                continue;
            }

            if (
                _revised[i].RiskCriteriaText == null ||
                _revised[i].RiskCriteriaText == "" ||
                _revised[i].RiskCriteriaText.indexOf("N/A") !== -1 ||
                _revised[i].Code == null
            ) {
                continue;
            }

            if (!isValidRiskType(_revised[i].RiskFieldName)) {
                continue;
            }

            riskMatrixId = getCircleGroup(_revised[i].RiskCriteriaText);

            var circle = {
                Guid: _revised[i].Guid,
                rawData: _revised[i],
                code: _revised[i].Code,
                assesment: "R",
                RiskType: _revised[i].RiskType + " Risk",
                Title: _revised[i].Title,
                MatrixId: riskMatrixId,
                LastReviewedOn: _revised[i].LastReviewedOn,
            };

            if (!(guid in arrR)) {
                arrR[guid] = [];
            }

            arrR[guid].push(circle);
        }

        allCircles.R = arrR;
    }

    if (_bFuture) {
        var riskMatrixId;
        var guid;

        for (i = 0; i < _future.length; ++i) {
            guid = _future[i].Guid;
            if (guidList != null && jQuery.inArray(guid, guidList) == -1) {
                continue;
            }

            if (
                _future[i].RiskCriteriaText == null ||
                _future[i].RiskCriteriaText == "" ||
                _future[i].RiskCriteriaText.indexOf("N/A") !== -1 ||
                _future[i].Code == null
            ) {
                continue;
            }

            if (!isValidRiskType(_future[i].RiskFieldName)) {
                continue;
            }

            riskMatrixId = getCircleGroup(_future[i].RiskCriteriaText);

            var circle = {
                Guid: _future[i].Guid,
                rawData: _future[i],
                code: _future[i].Code,
                assesment: "F",
                RiskType: _future[i].RiskType + " Risk",
                Title: _future[i].Title,
                MatrixId: riskMatrixId,
                LastReviewedOn: _future[i].LastReviewedOn,
            };

            if (!(guid in arrF)) {
                arrF[guid] = [];
            }

            arrF[guid].push(circle);
        }

        allCircles.F = arrF;
    }

    groupCirclesPerBox(_isHistoryMode);

    Object.keys(circlesPerMatrix).forEach(function (matrixId) {
        if (matrixId != "anyany") {
            //when risk criteria text is empty, 'matrixid' will be 'anyany', so I did this to handle it
            for (i = 0; i < circlesPerMatrix[matrixId].length; ++i) {
                var circleCount = circlesPerMatrix[matrixId].length;
                try {
                    var box = d3.select($(jq(matrixId)).get(0)).datum();

                    if (i == 11) {
                        drawCircle(
                            circleCount,
                            box,
                            circlesPerMatrix[matrixId][
                                circlesPerMatrix[matrixId].length - 1
                            ],
                            i
                        );
                        drawCircle(
                            circleCount,
                            box,
                            circlesPerMatrix[matrixId][i],
                            i
                        );
                    } else {
                        drawCircle(
                            circleCount,
                            box,
                            circlesPerMatrix[matrixId][i],
                            i
                        );
                    }
                } catch (e) {}
            }
        }
    });

    group_Circles.selectAll("g").transition("opacity").attr("fill-opacity", 1);

    if (_isHistoryMode) {
        group_Circles.selectAll("g").each(function (d, i) {
            if (i === 0) {
                _circleClicked = false;
                d3.select(this).dispatch("click");
            }
        });
    }

    hideToolTipWhenLoading();
}

function jq(myid) {
    return "#" + myid.replace(/([ !"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~])/g, "\\$1");
}

function comapareDates(a, b) {
    //return new Date(parseInt(b.datum().LastReviewedOn.substr(6))) - Date(parseInt(a.datum().LastReviewedOn.substr(6)));
    if(a.datum().LastReviewedOn != null && b.datum().LastReviewedOn != null){
        return (
            new Date(a.datum().LastReviewedOn) -
            new Date(b.datum().LastReviewedOn)
        );
    }
}

function compareRiskRatings(a, b) {
    if (a.Value < b.Value) {
        return -1;
    }

    if (a.Value > b.Value) {
        return 1;
    }

    return 0;
}

function getMatchingRiskMatrixIndex(xCritiria, yCritiria) {
    for (var i = 0; i < _jsonRiskMatrix.length; i++) {
        if (
            _jsonRiskMatrix[i].XAxis == xCritiria &&
            _jsonRiskMatrix[i].YAxis == yCritiria
        ) {
            return i;
        }
    }
    return -1;
}

function drawAxisLabels() {
    d3.select("#group_Axislabels").remove();
    group_AxisLabels = group_MainGroup
        .append("g")
        .attr("id", "group_Axislabels");

    // X-Axis Label
    group_AxisLabels
        .append("text")
        .text(_xAxisItems[0].RiskCriteria.RiskCriteriaName)
        .attr("x", (_xAxisItems.length * 240) / 2)
        .attr("y", 120 * _yAxisItems.length + 60)
        .attr("font-size", "18px")
        .attr("font-weight", "normal")
        .attr("color", "#323250")
        .attr("font-family", "Graphik Semibold Desktop")
        .style("fill", "#323250")
        .attr("text-anchor", "middle");

    // Y-Axis Label
    group_AxisLabels
        .append("text")
        .text(_yAxisItems[0].RiskCriteria.RiskCriteriaName)
        .attr("x", -100)
        .attr("y", (_yAxisItems.length * 120) / 2)
        .attr("font-size", "18px")
        .attr("font-weight", "normal")
        .attr("color", "#323250")
        .attr("font-family", "Graphik Semibold Desktop")
        .attr("display", "table")
        .style("fill", "#323250")
        .attr(
            "transform",
            "rotate(270," + -150 + "," + (_yAxisItems.length * 120) / 2 + ")"
        )
        .attr("text-anchor", "middle");

    // Y-Axis Values
    for (var i = 0; i < _yAxisItems.length; ++i) {
        group_AxisLabels
            .append("foreignObject")
            .style("width", "100px")
            .style("height", "120px")
            .attr("x", -105)
            .attr("y", 120 * (_yAxisItems.length - i) - 60)
            .append("xhtml:div")
            .text(_yAxisItems[i].RiskCriteriaRatingDisplayName)
            // .style("fill", "#323250")
            .attr("text-anchor", "end")
            .attr("color", "#323250")
            .style("text-align", "right")
            .style("font-size", "14px")
            .style("color", "#323250")
            .style("overflow", "visible")
            .style("word-break", "break-word")
            .style("line-height", "18px")
            .attr("text-anchor", "middle");
    }

    // X-Axis Values
    for (var i = 0; i < _xAxisItems.length; ++i) {
        group_AxisLabels
            .append("foreignObject")
            .style("width", "170px")
            .style("height", "120px")
            .attr("x", 240 * i + 40)
            .attr("y", 120 * _yAxisItems.length + 5)
            .append("xhtml:div")
            .text(_xAxisItems[i].RiskCriteriaRatingDisplayName)
            .attr("font-weight", "normal")
            .attr("color", "#323250")
            .attr("font-family", "Graphik Regular Desktop")
            // .style("fill", "#323250")
            .style("text-align", "center")
            .style("font-size", "14px")
            .style("color", "#323250")
            .style("overflow", "visible")
            .style("word-break", "break-word")
            .style("line-height", "18px")
            .attr("text-anchor", "middle");
    }
}

function drawLegend() {
    d3.select("#legendSVG").remove();
    var legendColors = [];

    for (var i = 0; i < _riskRatingTypes.length; ++i) {
        legendColors[_riskRatingTypes[i].RiskRatingTypeTitle] =
            _riskRatingTypes[i].RiskRatingTypeColor;
    }

    var legendSVG = d3
        .select("div#legend")
        .append("svg")
        .attr("id", "legendSVG")
        .attr("width", Object.keys(legendColors).length * 120)
        .attr("height", 50);

    var count = 0;
    Object.keys(legendColors).forEach(function (key) {
        var color = legendColors[key];
        var xCor = count++ * 120;

        legendSVG
            .append("rect")
            .attr("x", xCor)
            .attr("y", 0)
            .attr("height", 8)
            .attr("width", 120)
            .style("stroke-width", 2)
            .style("stroke", "white")
            .style("fill", color);

        legendSVG
            .append("foreignObject")
            .text(key)
            .attr("x", xCor)
            .attr("y", 10)
            .attr("font-family", "Graphik Regular Desktop")
            .attr("font-size", "13px")
            .attr("font-weight", "normal")
            .attr("text-anchor", "middle")
            .style("text-align", "center")
            .attr("color", "#323250")
            .style("fill", "#323250")
            .style("overflow", "visible")
            .style("width", "120px")
            .style("word-break", "break-word")
            .style("line-height", "12px")
    });
}

function drawRects() {
    _xAxisItems = {};
    _yAxisItems = {};

    for (i = 0; i < _critiriaInfo.length; ++i) {
        if (_critiriaInfo[i].Criteria.FormulaCode == _xAxisFormula) {
            _xAxisItems = _critiriaInfo[i].Ratings;
            break;
        }
    }

    for (i = 0; i < _critiriaInfo.length; ++i) {
        if (_critiriaInfo[i].Criteria.FormulaCode == _yAxisFormula) {
            _yAxisItems = _critiriaInfo[i].Ratings;
            break;
        }
    }

    if (_xAxisItems.length <= 0 || _yAxisItems.lenght <= 0) {
        alert("No Critiria info found for selected critirias");
        return;
    }

    drawAxisLabels();
    drawLegend();

    rectangles = [];

    for (var i = 0; i < _xAxisItems.length; ++i) {
        var index = _yAxisItems.length;

        for (var index = 0; index < _yAxisItems.length; ++index) {
            var riskMatrixIndex = getMatchingRiskMatrixIndex(
                _xAxisItems[i].RiskCriteriaRatingName,
                _yAxisItems[index].RiskCriteriaRatingName
            );

            if (riskMatrixIndex == -1) {
                continue;
            }

            var boxId = getCircleGroup(
                _jsonRiskMatrix[riskMatrixIndex].CriteriaText
            );
            var color = _jsonRiskMatrix[riskMatrixIndex].RatingColor;

            rectangles.push({
                x: i * 240,
                y: (_yAxisItems.length - index - 1) * 120,
                height: 120,
                width: 240,
                id: boxId,
                color: color,
                riskMatrixIndex: riskMatrixIndex,
            });
        }
    }

    d3.select("#group_MatrixRectangles").remove();
    group_MatrixRectangles = group_MainGroup
        .append("g")
        .attr("id", "group_MatrixRectangles");

    var D3rectangles = group_MatrixRectangles
        .selectAll("rect")
        .data(rectangles)
        .enter()
        .append("rect");

    var rectangleAttributes = D3rectangles.attr("id", function (d) {
        return d.id;
    })
        .attr("x", function (d) {
            return d.x;
        })
        .attr("y", function (d) {
            return d.y;
        })
        .attr("height", function (d) {
            return d.height;
        })
        .attr("width", function (d) {
            return d.width;
        })
        .style("stroke-width", 2)
        .attr("tabindex", "0") 
        //.on("click", function (d) {
        //    hideDetails();
        //})
        .style("stroke", "white")
        .style("fill", function (d) {
            return d.color;
        })
        .on("focus", function () {
            // Add a style change for focused state
            d3.select(this).style("stroke", "blue").style("stroke-width", 4);
        })
        .on("blur", function () {
            // Revert style change when losing focus
            d3.select(this).style("stroke", "white").style("stroke-width", 2);
        })
        .attr("aria-label", function (event) {
            return event.id;
        });

    var width = _xAxisItems.length * rectangles[0].width + 100;

    document.getElementById("newHeatMap").style.width = width + "px";
    svgContainer
        .attr("width", "100%")
        .attr("preserveAspectRatio", "xMinYMin meet");
}

function saveSnapshot(selectedRiskGuid) {
    _initialSnapshot = _initial;
    _revisedSnapshot = _revised;
    _futureSnapshot = _future;
    _selectedRiskGuid = selectedRiskGuid;
}

function restoreSnapshot() {
    _initial = _initialSnapshot;
    _revised = _revisedSnapshot;
    _future = _futureSnapshot;

    selectedRiskGuid = _selectedRiskGuid;
    var Array = [selectedRiskGuid];
    drawCircles(Array);

    //_isHistoryMode = false;
    drawCircles();
    //drawArrowsForAll();
}

function hideDetails() {
    if (_isHistoryMode) {
        $("#checkFetchHistory").prop("checked", false);
        _isHistoryMode = false;
        restoreSnapshot();
        drawCircles();
        drawArrowsForAll();
        return;
    }

    $("#riskDetails").slideUp("slow");
    _circleClicked = false;

    if (_filteredCircleMode) {
        _filteredCircleMode = false;
        drawCircles();
    }

    highlightCircles();
    drawArrowsForAll();
}

function getAssementText(assesmentCode) {
    if (assesmentCode == "F") {
        return _FutureAssesmentCodeText;
    } else if (assesmentCode == "I") {
        return _InitialAssesmentCodeText;
    } else {
        return _RevisedAssesmentCodeText;
    }
}

function getCircleColor(assessment) {
    if (assessment == "F") {
        return "black";
    } else if (assessment == "I") {
        return "#CECECE";
    } else {
        return "white";
    }
}

function getCircleGroup(str) {
    var xCritiriaText =
        str != null
            ? str
                  .substring(
                      str.indexOf(
                          "[" + _critiriaInfo[0].Criteria.FormulaCode + "]"
                      )
                  )
                  .split("|", 1)[0]
                  .split(":", 2)[1]
            : "";
    var yCritiriaText =
        str != null
            ? str
                  .substring(
                      str.indexOf(
                          "[" + _critiriaInfo[1].Criteria.FormulaCode + "]"
                      )
                  )
                  .split("|", 1)[0]
                  .split(":", 2)[1]
            : "";

    var final = removeSpaces(xCritiriaText + yCritiriaText);
    return final;
    // return "minoralmostcertain";

    //str = str.replace(/\|/g, '');
    //str = str.replace(/\:/g, '');
    //str = str.replace(/\[C\]/g, '');
    //str = str.replace(/\[L\]/g, '');
    //return removeSpaces(str);
}

function removeSpaces(str) {
    return str.replace(/\s/g, "").replace("/", "").toLowerCase();
}

function findCircleX(circleGroup) {
    return d3.select("#" + circleGroup).datum().x + 29;
}

function findCircleY(circleGroup) {
    return d3.select("#" + circleGroup).datum().y + 28;
}

function setSVGContainer() {
    //$('#showTrackLines').change(function () {
    //    if (this.checked) {
    //        drawArrowsForAll();
    //    }
    //    else {
    //        hideDetails();
    //    }
    //});

    d3.select("#d3MainChart").remove();
    const countH = _critiriaInfo[1].Ratings.length;
    const countW = _critiriaInfo[0].Ratings.length;
    svgContainer = d3
        .select("div#newHeatMap")
        .append("svg")
        .attr("width", 216 * (countW + 1))
        .attr("height", 120 * (countH + 1))
        .attr("id", "d3MainChart");

    var defs = svgContainer.append("defs");
    var temp = defs
        .append("marker")
        .attr("id", "arrow")
        .attr("viewBox", "0 -5 10 10")
        .attr("refX", 9)
        .attr("refY", 0)
        .attr("markerWidth", 4)
        .attr("markerHeight", 4)
        .style("fill", "purple")
        .attr("orient", "auto");

    temp.append("path").attr("d", "M0,-5L10,0L0,5").attr("class", "arrowHead");

    group_MainGroup = svgContainer
        .append("g")
        .attr("transform", "translate(165,0), scale(0.9)")
        .attr("id", "group_main");

    var linkClickBack = document.getElementById("backURL");
    if (linkClickBack != null) {
        linkClickBack.onclick = hideDetails;
    }
}

function convertJsonDate(date) {
    if (date == null || date == "") {
        return "-";
    } else {
        // var parsedDate = new Date(parseInt(date.substr(6)));
        //
        // if ((parsedDate.getDate() === _minDate.getDate()) || (isNaN(parsedDate.getDate()))) {
        // 	return '-';
        // }

        return new Date(date).toLocaleString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
        });
    }
}

var exportCountHack = 0;
function ExportToPDF() {
    var imagesToLoad = 5; // Total number of images to load
    var imagesLoaded = 0; // Number of images loaded

    if(!_isInitialEnabled || !_bIinitial){
        imagesToLoad--;
    }

    if(!_isRevisedEnabled || !_bRevised){
        imagesToLoad--;
    }

    if(!_isFutureEnabled || !_bFuture){
        imagesToLoad--;
    }
    
    // Function to increment the loaded count and check if all images are loaded
    function imageLoaded() {
        imagesLoaded++;
        if (imagesLoaded === imagesToLoad) {
            generatePDF();
        }
    }

    exportCountHack = 0;
    var heatMapSVG = document.querySelector("#d3MainChart");
    var tgtImage = document.querySelector("#diagram_png");
    var heatMapCanvas = createHighQualityCanvas(heatMapSVG);
    var heatMapImg = new Image();

    var svgAsXML = new XMLSerializer().serializeToString(heatMapSVG);
    heatMapImg.src = "data:image/svg+xml," + encodeURIComponent(svgAsXML);

    heatMapImg.onload = function () {
        try {
            drawImageOnCanvas(heatMapCanvas, heatMapImg);
            tgtImage.src = heatMapCanvas.toDataURL('image/png', 0.95);
            imageLoaded(); // Increment the loaded count
        } catch (err) {
            alert("PDF export supported only in Edge and Chrome");
        }
    };

    var initialCanvas, revisedCanvas, futureCanvas;

    if (_bIinitial) {

        var initialSvg = document.querySelector("#initialSvg");
        var initialImage = document.querySelector("#initial_png");
        var initialCanvas1 = document.createElement("canvas");
        var loaderInitial = new Image();

        loaderInitial.width =
            initialCanvas1.width =
                initialImage.width =
                    initialSvg.getBBox().width;
        loaderInitial.height =
            initialCanvas1.height =
                initialImage.height =
                    initialSvg.getBBox().height;

        initialCanvas = createHighQualityCanvas(document.querySelector("#initialSvg"));
        var svgAsXMLInitial = new XMLSerializer().serializeToString(initialSvg);
        loaderInitial.src = "data:image/svg+xml," + encodeURIComponent(svgAsXMLInitial);

        loaderInitial.onload = function () {
            drawImageOnCanvas(initialCanvas, loaderInitial);
            imageLoaded(); // Increment the loaded count
        };
    }

    if (_bRevised) {

        var revisedSvg = document.querySelector("#revisedSvg");
        var revisedImage = document.querySelector("#revised_png");
        var revisedCanvas1 = document.createElement("canvas");
        var loaderRevised = new Image();

        loaderRevised.width =
            revisedCanvas1.width =
                revisedImage.width =
                    revisedSvg.getBBox().width;
        loaderRevised.height =
            revisedCanvas1.height =
                revisedImage.height =
                    revisedSvg.getBBox().height;

        revisedCanvas = createHighQualityCanvas(document.querySelector("#revisedSvg"));
        var svgAsXMLRevised = new XMLSerializer().serializeToString(revisedSvg);
        loaderRevised.src = "data:image/svg+xml," + encodeURIComponent(svgAsXMLRevised);

        loaderRevised.onload = function () {
            drawImageOnCanvas(revisedCanvas, loaderRevised);
            imageLoaded(); // Increment the loaded count
        };
    }

    if (_bFuture) {
        var futureSvg = document.querySelector("#futureSvg");
        var futureImage = document.querySelector("#future_png");
        var futureCanvas1 = document.createElement("canvas");
        var loaderFuture = new Image();

        loaderFuture.width =
            futureCanvas1.width =
                futureImage.width =
                    futureSvg.getBBox().width;
        loaderFuture.height =
            futureCanvas1.height =
                futureImage.height =
                    futureSvg.getBBox().height;

        futureCanvas = createHighQualityCanvas(document.querySelector("#futureSvg"));
        var svgAsXMLFuture = new XMLSerializer().serializeToString(futureSvg);
        loaderFuture.src = "data:image/svg+xml," + encodeURIComponent(svgAsXMLFuture);

        loaderFuture.onload = function () {
            drawImageOnCanvas(futureCanvas, loaderFuture);
            imageLoaded(); // Increment the loaded count
        };
    }

    var mySVG2 = document.querySelector("#legendSVG");
    var tgtImage2 = document.querySelector("#legend_png");
    var can2 = createHighQualityCanvas(mySVG2);
    var loader2 = new Image();
    var scaleFactor2 = 2;
    loader2.width = can2.width = can2.height = tgtImage2.width = mySVG2.getBBox().width * scaleFactor2;
    loader2.height = loader2.width;
    var svgAsXML2 = new XMLSerializer().serializeToString(mySVG2);
    loader2.src = "data:image/svg+xml," + encodeURIComponent(svgAsXML2);
    loader2.onload = function () {
        drawImageOnCanvas(can2, loader2);
        tgtImage2.src = can2.toDataURL('image/png', 0.95);
        imageLoaded(); // Increment the loaded count
    };

    function createHighQualityCanvas(svgElement) {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");

        var scaleFactor = 2; // Increase this value for higher resolution
        canvas.width = svgElement.getBBox().width * scaleFactor;
        canvas.height = svgElement.getBBox().height * scaleFactor;

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        return canvas;
    }

    function drawImageOnCanvas(canvas, img) {
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    }

    function generatePDF() {
        PopulateRiskListTable();
        var options = {};

        var pdf = new jsPDF("l", "mm", "a4");
        pdf.addImage(can2.toDataURL(), "JPEG", 10, 10, 100, 5);
        if (_bIinitial && initialCanvas != null) {
            pdf.addImage(initialCanvas.toDataURL('image/png', 0.95), "PNG", 140, 4,60,10);
        }
        if (_bRevised && revisedCanvas != null) {
            pdf.addImage(revisedCanvas.toDataURL('image/png', 0.95), "PNG", 190, 4,60,10);
        }
        if (_bFuture && futureCanvas != null) {
            pdf.addImage(futureCanvas.toDataURL('image/png', 0.95), "PNG", 240, 4,60,10);
        }
        pdf.addImage(heatMapCanvas.toDataURL('image/png', 0.95), 'PNG', 10, 20, 520, 200);
        pdf.addPage();
        pdf.autoTable({ html: "#risksTable" });
        pdf.save(_translationKeyValuePair.CAMMSRiskHeatmapPDF +'.pdf');
    }
}


function ExportToWord() {
    exportCountHack = 0;
    var scaleFactorForHeatMap = 1;
    var heatMapSVG = document.querySelector("#d3MainChart");
    var tgtImage = document.querySelector("#diagram_png");
    var heatMapCanvas = document.createElement("canvas");
    var ctxHeatMap = heatMapCanvas.getContext("2d");
    var heatMapImg = new Image();

    heatMapImg.width =
        heatMapCanvas.width =
        tgtImage.width =
            heatMapSVG.getBBox().width;
    heatMapImg.height =
        heatMapCanvas.height =
        tgtImage.height =
            heatMapSVG.getBBox().height;


    var svgAsXML = new XMLSerializer().serializeToString(heatMapSVG);
    heatMapImg.src = "data:image/svg+xml," + encodeURIComponent(svgAsXML);



    heatMapImg.onload = function () {
        ctxHeatMap.imageSmoothingEnabled = true;
        ctxHeatMap.imageSmoothingQuality = 'high';

        ctxHeatMap.drawImage(
            heatMapImg,
            0,
            0,
            heatMapImg.width * scaleFactorForHeatMap,
            heatMapImg.height * scaleFactorForHeatMap
        );
        tgtImage.src = heatMapCanvas.toDataURL('image/png', 0.95);
    };

    if (_bIinitial) {
        var initialSvg = document.querySelector("#initialSvg");
        var initialImage = document.querySelector("#initial_png");
        var initialCanvas = document.createElement("canvas");
        var ctxInitial = initialCanvas.getContext("2d");
        var loaderInitial = new Image();

        loaderInitial.width =
            initialCanvas.width =
            initialImage.width =
                initialSvg.getBBox().width;
        loaderInitial.height =
            initialCanvas.height =
            initialImage.height =
                initialSvg.getBBox().height;

        var svgAsXMLInitial = new XMLSerializer().serializeToString(initialSvg);
        loaderInitial.src =
            "data:image/svg+xml," + encodeURIComponent(svgAsXMLInitial);

        loaderInitial.onload = function () {
            ctxInitial.drawImage(
                loaderInitial,
                0,
                0,
                loaderInitial.width,
                loaderInitial.height
            );
            initialImage.src = initialCanvas.toDataURL();
        };
    } else {
        $("#printableInitial").hide();
    }

    if (_bRevised) {
        var revisedSvg = document.querySelector("#revisedSvg");
        var revisedImage = document.querySelector("#revised_png");
        var revisedCanvas = document.createElement("canvas");
        var ctxRevised = revisedCanvas.getContext("2d");
        var loaderRevised = new Image();

        loaderRevised.width =
            revisedCanvas.width =
            revisedImage.width =
                revisedSvg.getBBox().width;
        loaderRevised.height =
            revisedCanvas.height =
            revisedImage.height =
                revisedSvg.getBBox().height;

        var svgAsXMLRevised = new XMLSerializer().serializeToString(revisedSvg);
        loaderRevised.src =
            "data:image/svg+xml," + encodeURIComponent(svgAsXMLRevised);

        loaderRevised.onload = function () {
            ctxRevised.drawImage(
                loaderRevised,
                0,
                0,
                loaderRevised.width,
                loaderRevised.height
            );
            revisedImage.src = revisedCanvas.toDataURL();
        };
    } else {
        $("#printableRevised").hide();
    }

    if (_bFuture) {
        var futureSvg = document.querySelector("#futureSvg");
        var futureImage = document.querySelector("#future_png");
        var futureCanvas = document.createElement("canvas");
        var ctxFuture = futureCanvas.getContext("2d");
        var loaderFuture = new Image();

        loaderFuture.width =
            futureCanvas.width =
            futureImage.width =
                futureSvg.getBBox().width;
        loaderFuture.height =
            futureCanvas.height =
            futureImage.height =
                futureSvg.getBBox().height;

        var svgAsXMLFuture = new XMLSerializer().serializeToString(futureSvg);
        loaderFuture.src =
            "data:image/svg+xml," + encodeURIComponent(svgAsXMLFuture);

        loaderFuture.onload = function () {
            ctxFuture.drawImage(
                loaderFuture,
                0,
                0,
                loaderFuture.width,
                loaderFuture.height
            );
            futureImage.src = futureCanvas.toDataURL();
        };
    } else {
        $("#printableFuture").hide();
    }

    var mySVG2 = document.querySelector("#legendSVG");
    var tgtImage2 = document.querySelector("#legend_png");
    var can2 = document.createElement("canvas");
    var ctx2 = can2.getContext("2d");
    var loader2 = new Image();

    var scaleFactor = 5;
    loader2.width = can2.width = tgtImage2.width = mySVG2.getBBox().width * scaleFactor;
    loader2.height = can2.height = tgtImage2.height = mySVG2.getBBox().height * scaleFactor;

    var svgAsXML2 = new XMLSerializer().serializeToString(mySVG2);
    loader2.src = "data:image/svg+xml," + encodeURIComponent(svgAsXML2);

    loader2.onload = function () {
        try {
            ctx2.drawImage(loader2, 0, 0, loader2.width, loader2.height);
            tgtImage2.src = can2.toDataURL('image/png', 0.95);
        } catch (err) {
            alert("Word export supported only Edge and Chrome");
        }
    };

    $("#legend_png")
        .unbind("load")
        .load("data:,Hello", function (e) {
            exportCountHack++;

            if (exportCountHack == 1) {
                PopulateRiskListTable();
                $("#printableView").wordExport( _translationKeyValuePair.CAMMSRiskHeatmapWord );
            }
        });
}

function PopulateRiskListTable() {
    var riskCodeLabel = $("[id*='_Riskcodelbl']");
    var riskTitleLabel = $("[id*='_Risktitlelbl']");

    var riskCodeLabelText =  _translationKeyValuePair.RiskCode ;
    var riskTitleLabelText =  _translationKeyValuePair.RiskTitle ;

    if (riskCodeLabel != null && riskCodeLabel.text() != "") {
        riskCodeLabelText = riskCodeLabel.text().replace(":", "");
    }

    if (riskTitleLabel != null && riskTitleLabel.text() != "") {
        riskTitleLabelText = riskTitleLabel.text().replace(":", "");
    }

    $("#riskList").empty();

    var risksTable = $(
        '<table id="risksTable" class="tableDetails">' +
            "<thead>" +
            "<tr>" +
            "<th>" +
            riskCodeLabelText +
            "</th>" +
            "<th>" +
            riskTitleLabelText +
            "</th>" +
            "</tr>" +
            "</thead>" +
            "<tbody>" +
            getRiskRows() +
            "</tbody>" +
            "</table>"
    );

    $(risksTable).appendTo("#riskList");
}

function getRiskRows() {
    var final = "";
    var collection = [];

    if (_bIinitial) {
        for (var i = 0; i < _initial.length; ++i) {
            if (arrI.hasOwnProperty(_initial[i].Guid)) {
                collection.push(_initial[i]);
            }
        }
    }

    if (_bRevised) {
        for (var r = 0; r < _revised.length; ++r) {
            if (collection.length > 0) {
                if (arrR.hasOwnProperty(_revised[r].Guid)) {
                    var found = false;
                    for (var x = 0; x < collection.length; x++) {
                        if (collection[x].Guid == _revised[r].Guid) {
                            found = true;
                            break;
                        }
                    }

                    if (!found) {
                        collection.push(_revised[r]);
                    }
                }
            } else {
                if (arrR.hasOwnProperty(_revised[r].Guid)) {
                    collection.push(_revised[r]);
                }
            }
        }
    }

    if (_bFuture) {
        for (var k = 0; k < _future.length; ++k) {
            if (collection.length > 0) {
                if (arrF.hasOwnProperty(_future[k].Guid)) {
                    var found = false;
                    for (var l = 0; l < collection.length; l++) {
                        if (collection[l].Guid == _future[k].Guid) {
                            found = true;
                            break;
                        }
                    }

                    if (!found) {
                        collection.push(_future[k]);
                    }
                }
            } else {
                if (arrF.hasOwnProperty(_future[k].Guid)) {
                    collection.push(_future[k]);
                }
            }
        }
    }

    for (var t = 0; t < collection.length; ++t) {
        final =
            final +
            "<tr>" +
            "<td>" +
            collection[t].Code +
            "</td>" +
            "<td>" +
            collection[t].Title +
            "</td>" +
            "</tr>";
    }

    return final;
}

function drawArrowsForHiddenCircles(guid, arrayI, arrayR, arrayF) {
    var selectedInitialRisk = _initial.filter(function (i) {
        return guid == i.Guid;
    })[0];

    var selectedRevisedRisk = _revised.filter(function (r) {
        return guid == r.Guid;
    })[0];

    var selectedFutureRisk = _future.filter(function (f) {
        return guid == f.Guid;
    })[0];

    var initialRiskCriteriaMatrixID;
    var revisedRiskCriteriaMatrixID;
    var futureRiskCriteriaMatrixID;

    var initialRiskCircleID;
    var revisedRiskCircleID;
    var futureRiskCircleID;

    if (
        _bIinitial == true &&
        arrayI.length == 0 &&
        selectedInitialRisk != null
    ) {
        initialRiskCriteriaMatrixID = getCircleGroup(
            selectedInitialRisk.RiskCriteriaText
        );
        var initialMatrixExist = false;

        if (initialRiskCriteriaMatrixID != null && allCircles.I != null) {
            Object.keys(allCircles.I).forEach(function (key, index) {
                if (
                    initialMatrixExist == false &&
                    initialRiskCriteriaMatrixID ==
                        allCircles.I[key][0]["MatrixId"] &&
                    allCircles.I[key][0]["isMoreCircle"] == true
                ) {
                    initialRiskCircleID = allCircles.I[key][0]["Guid"];

                    group_Circles
                        .selectAll("g")
                        .filter(function (d) {
                            return initialRiskCircleID == d.Guid;
                        })
                        .each(function (g) {
                            var d3Circle = d3.select(this).select("circle");

                            if (
                                g.assesment == "I" &&
                                g.MatrixId == initialRiskCriteriaMatrixID
                            ) {
                                arrayI.push(d3Circle);
                                changeBorder(d3Circle, true);
                            }
                        });

                    initialMatrixExist = true;
                }
            });
        }
    }

    if (arrayR.length == 0 && selectedRevisedRisk != null) {
        revisedRiskCriteriaMatrixID = getCircleGroup(
            selectedRevisedRisk.RiskCriteriaText
        );
        var revisedMatrixExist = false;

        if (revisedRiskCriteriaMatrixID != null && allCircles.R != null) {
            Object.keys(allCircles.R).forEach(function (key, index) {
                if (
                    revisedMatrixExist == false &&
                    revisedRiskCriteriaMatrixID ==
                        allCircles.R[key][0]["MatrixId"] &&
                    allCircles.R[key][0]["isMoreCircle"] == true
                ) {
                    revisedRiskCircleID = allCircles.R[key][0]["Guid"];

                    group_Circles
                        .selectAll("g")
                        .filter(function (d) {
                            return revisedRiskCircleID == d.Guid;
                        })
                        .each(function (g) {
                            var d3Circle = d3.select(this).select("circle");

                            if (
                                g.assesment == "R" &&
                                g.MatrixId == revisedRiskCriteriaMatrixID
                            ) {
                                arrayR.push(d3Circle);
                                changeBorder(d3Circle, true);
                            }
                        });

                    revisedMatrixExist = true;
                }
            });
        }
    }

    if (_bFuture && arrayF.length == 0 && selectedFutureRisk != null) {
        futureRiskCriteriaMatrixID = getCircleGroup(
            selectedFutureRisk.RiskCriteriaText
        );
        var futureMatrixExist = false;

        if (futureRiskCriteriaMatrixID != null && allCircles.F != null) {
            Object.keys(allCircles.F).forEach(function (key, index) {
                if (
                    futureMatrixExist == false &&
                    futureRiskCriteriaMatrixID ==
                        allCircles.F[key][0]["MatrixId"] &&
                    allCircles.F[key][0]["isMoreCircle"] == true
                ) {
                    futureRiskCircleID = allCircles.F[key][0]["Guid"];

                    group_Circles
                        .selectAll("g")
                        .filter(function (d) {
                            return futureRiskCircleID == d.Guid;
                        })
                        .each(function (g) {
                            var d3Circle = d3.select(this).select("circle");

                            if (
                                g.assesment == "F" &&
                                g.MatrixId == futureRiskCriteriaMatrixID
                            ) {
                                arrayF.push(d3Circle);
                                changeBorder(d3Circle, true);
                            }
                        });

                    futureMatrixExist = true;
                }
            });
        }
    }
}

function getAllRiskRatingTypes(riskRatingTypes) {
    _riskRatingTypes = riskRatingTypes;
}

function drawArrowsInTimelineTrend(){
    group_Circles.selectAll("g").each(function (d) {
        drawArrows(d.Guid, this, 2);
    });
}
